export const translations = {
  en: {
    // Navigation
    about: 'About',
    contact: 'Contact',
    connections: 'Connections',
    faq: 'FAQ',
    
    // Home page
    welcome: 'Welcome to SDeal',
    subtitle: 'Your trusted marketplace across Europe',
    visitCountry: 'Visit SDeal',
    chooseCountry: 'Choose Your Country',
    startSelling: 'Start selling',
    aboutText: 'SDeal connects retailers and wholesalers with consumers through high-quality online marketing expertise. Our IT platform is continually evolving to help our partners boost their sales and maintain full control over their orders and customer data.',
    aboutText2: 'Unlike large e-commerce players who dominate and take over the full customer journey, SDeal empowers partners to grow while staying in control. We offer independent support and marketing power without becoming your competitor.',
    
    // Footer
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions',
    jobs: 'Jobs',
    
    // Language names
    english: 'English',
    dutch: 'Dutch',
    german: 'German',
    french: 'French',
    
    // Products
    products: 'Our Products',
    productsIntro: 'Discover our comprehensive range of products and services designed to help your business grow.',
    catalogSearchTitle: 'Product catalog',
    catalogSearchPlaceholder: 'Search by name or SKU (min. 2 characters)',
    catalogSearchButton: 'Search',
    catalogEmpty: 'No matching products in our catalog yet.',
    catalogHint: 'Browse all active products or narrow down with search.',
    catalogLoadError: 'Could not load the catalog. Please try again later.',
    catalogUnauthorized: 'Your session has expired or you do not have access. Please sign in again as an admin.',
    catalogViewOnShop: 'View',
    catalogLoading: 'Loading…',
    catalogOf: 'of',
    catalogPagination: 'Pagination',
    catalogPrevPage: 'Previous page',
    catalogNextPage: 'Next page',
    catalogShow: 'Show',
    catalogSortBy: 'Sort by',
    catalogSortPosition: 'Name A–Z',
    catalogSortNameDesc: 'Name Z–A',
    catalogSortPriceAsc: 'Price: low to high',
    catalogSortPriceDesc: 'Price: high to low',
    catalogViewMode: 'View mode',
    catalogViewGrid: 'Grid view',
    catalogViewList: 'List view',
    catalogType: 'Type',
    marketplace: 'Marketplace Platform',
    marketplaceDesc: 'Advanced e-commerce platform connecting retailers and wholesalers with consumers across Europe.',
    marketplaceDetailed: 'SDeal Marketplace\n\nSDeal is an international marketplace where sellers can offer their products to consumers in seven European countries. The platform combines the reach of a major sales channel with smart marketing automation. Sellers get full control over their prices, commissions and product offerings, while SDeal handles traffic, advertising and conversion optimization.\n\nThe strength of SDeal lies in the connection between performance marketing and marketplace sales. For each product, the set commission is directly used to attract targeted traffic, particularly via Google Shopping. Competitive prices and in-demand products are therefore automatically rewarded with more visibility.\n\nSDeal also offers sellers a repricer tool and an extensive dashboard to track sales performance and optimize prices. This way, sellers can compete on both price and performance, while the platform handles marketing.\n\nWe offer three options:\n\n1. Marketplace with fixed commission\nWith a fixed commission, you benefit from automatic marketing. SDeal handles traffic, advertising and conversion optimization.\n\n2. Marketplace with self-set commission\nWith your own commission setting, you also benefit from automatic marketing. SDeal handles traffic, advertising and conversion optimization.\n\n3. CPC (CaaS)\nWith Clicks as a Service, you pay a fixed monthly amount for visibility and traffic. No automatic marketing is performed.\n\nIn short: SDeal is a marketplace that not only sells, but actively grows with the performance of its sellers, transparent, scalable and fully focused on returns.',
    dealCSS: 'Productdeal.com CSS',
    dealCSSDesc: 'Up to 20% discount on Google Shopping click costs. When you bid 1 euro per click, 100% goes to the auction instead of 80%, resulting in a 25% bid increase without extra effort.',
    dealCSSDetailed: 'Productdeal.com CSS\n\nWith Productdeal.com CSS, SDeal offers sellers the opportunity to advertise through our own Comparison Shopping Service (CSS), a Google-recognized comparison service.\n\nInstead of advertising directly through Google Shopping, the ad display runs through Productdeal.com CSS. This is not only fully compatible with your existing Merchant Center, but also delivers direct benefits in Google\'s ad auctions.\n\nWhat is a CSS?\n\nA CSS (Comparison Shopping Service) is an independent party that displays product ads on behalf of webshops in Google Shopping. Since European competition rules require Google to share its Shopping space with external providers, sellers can advertise more cheaply through a CSS.\n\nWhy choose Productdeal.com CSS\n\nUp to 20% lower click prices (CPC)\nGoogle offers a structural discount on clicks purchased through an external CSS. Sellers who advertise through Productdeal.com CSS therefore directly benefit from lower costs per click.\n\nMore visibility with the same budget\nDue to lower click prices, you can generate more traffic with the same ad budget or perform better in Google Shopping\'s auction position.\n\nWorks independently of SDeal\nProductdeal.com CSS works with your existing Merchant Center. Your current Merchant Center setup remains exactly the same. You only benefit from Google\'s discount on clicks purchased through an external CSS.\n\nTransparent and scalable\nYou retain insight into your performance and only pay the actual click or platform costs, without hidden commissions.\n\nIn summary\n\nProductdeal.com CSS is the smart way to advertise your products through Google Shopping, with lower click prices, higher visibility and without extra complexity.\n\nVisit productdeal.com for more about Productdeal.com CSS.',
    productdealLinkSite: 'Productdeal.com',
    productdealLinkCss: 'Productdeal.com CSS',
    productdealLinkMore: 'More on Productdeal.com',
    cpc: 'CPC (Cost Per Click)',
    cpcDesc: 'CAAS (Clicks as a Service). Place products that lead directly to your own webshop. Pay a fixed monthly amount for visibility and traffic via SDeal instead of commission per sale.',
    cpcDetailed: 'Clicks as a Service (CaaS)\n\nWith Clicks as a Service (CaaS), SDeal offers sellers a new way to be visible on our platform, without sales having to go through SDeal itself.\n\nInstead of billing per sale, you pay a fixed monthly amount for visibility and traffic from the SDeal platform. Visitors who click on your products are redirected directly to your own webshop.\n\nCaaS is ideal for brands and retailers who want to strengthen their own sales channel, but also want to benefit from the reach, product comparisons and traffic of SDeal.\n\nWhat it entails\n\nFixed monthly amount, no commission\nYou pay one clear rate per month, regardless of turnover or number of sales.\n\nTraffic directly to your webshop\nProduct clicks lead directly to your own site, so you retain customer contact and handling.\n\nVisibility within the SDeal ecosystem\nYour products appear in relevant categories and search results on the platform.\n\nNo campaigns, but reach\nWe do not run ads for these products, but ensure organic visibility through the platform and our feeds.\n\nIn summary\n\nWith CaaS, you increase the visibility of your webshop via SDeal, without commission per sale. A simple, transparent way to generate extra traffic and strengthen your brand, for a fixed monthly amount.',
    reviewFairifAI: 'Review (FairifAI)',
    reviewFairifAIDesc: 'Review tool with AI as referee. Collect reviews by inviting customers to review your business. AI moderates and reviews all reviews automatically.',
    magentoDevelopment: 'E-commerce Development',
    magentoDevelopmentDesc: 'Professional e-commerce development services. Custom modules, integrations, maintenance, and optimization for your e-commerce platform.',
    magentoDevelopmentDetailed: 'E-commerce Development Service\n\nWith our E-commerce Development Service, we help sellers and brands develop, optimize and maintain their webshop. Based on our own experience with the SDeal platform, we know exactly what is needed to build scalable, fast and conversion-focused e-commerce solutions.\n\nWe don\'t work with loose freelancers or anonymous agencies, but with a dedicated team of e-commerce specialists who work daily on performance, stability and integrations with feeds, marketplaces and advertising platforms.\n\nWhat you get\n\nE-commerce expertise from practice\nOur own platform runs on modern e-commerce technology, so we know what it takes to build successful online stores.\n\nComplete project guidance\nEvery project is managed by a dedicated product owner, included in the rate.\n\nTransparent approach\nWe charge a fixed hourly rate of €75, including product owner. No hidden costs, no surprises.\n\nFlexible deployment\nFrom one-time optimizations to structural development or maintenance contracts.\n\nSupported Platforms\n\nWe provide development services for the following e-commerce platforms:\n\n• Magento & Magento2\n• ACC (Adobe Commerce Cloud)\n• Shopify\n• Big-commerce\n• Drupal\n• Prestashop\n• Laravel\n• Lightspeed\n• WordPress Development\n\nFor whom\n\nThis service is intended for webshops that:\n\nwant to improve or speed up their existing e-commerce environment;\n\nneed new modules, integrations or design updates;\n\nwant to benefit from an experienced technical team without the overhead of a large agency.\n\nIn summary\n\nWith SDeal E-commerce Development, you choose an experienced partner who not only builds e-commerce solutions, but lives with them daily. Technically strong, commercially smart and fully transparent in costs and execution. At €75 per hour, including product owner.',
    ownMagentoStore: 'Own Magento Store',
    ownMagentoStoreDesc: 'Complete Magento store solutions. From setup to customization, we help you build and maintain your own powerful e-commerce store.',
    ownMagentoStoreDetailed: 'Own Magento Store\n\nDo you want a professional webshop without having to build everything from scratch? With SDeal Magento Store, we offer a completely set up environment based on our own platform, developed and refined over several years.\n\nOur infrastructure is optimized for speed, security and scalability. You directly benefit from the same stable foundation on which the SDeal platform itself runs, including integrations with payment providers, shipping services and product feeds.\n\nWhat you get\n\nFull Magento 2 webshop\nBuilt on a proven foundation with modern themes and optimal performance.\n\nHosting, maintenance and updates included\nWe take care of security, stability and regular optimizations.\n\nIntegration with SDeal and external marketplaces\nEasily publish products to multiple sales channels from one central environment.\n\nSupport from our development team\nOur Magento team is ready for customization and growth.\n\nCosts\n\nSetup costs: €1,995 (one-time)\n\nMonthly costs: €299 per month (including hosting, maintenance and support)\n\nIn summary\n\nWith SDeal Magento Store, you have a powerful, maintenance-free Magento 2 webshop, based on years of practical experience and optimized daily for performance and conversion. You focus on selling, we make sure everything runs.',
    analytics: 'Analytics & Insights',
    analyticsDesc: 'Comprehensive data analytics and business intelligence tools to optimize your sales performance.',
    support: '24/7 Support',
    supportDesc: 'Round-the-clock customer support and technical assistance for all our partners.',
    
    // Pricing
    pricingTitle: 'SDeal Pricing 2026',
    pricingDescription: 'Grow your webshop revenue with direct access to 200+ million consumers in Europe. Monthly packages go live in NL & BE; a yearly package unlocks all countries.',
    pricingSubtitle: 'Grow your webshop revenue with direct access to 200+ million consumers in Europe. Monthly: NL & BE. Yearly: all countries.',
    billingPeriod: 'Billing period',
    monthly: 'Monthly',
    yearly: 'Yearly',
    yearlySave: 'Save 25%',
    perMonth: 'month',
    perYear: 'year',
    noSetupCosts: 'No setup costs',
    startSellingToday: 'Start selling today',
    scaleSalesToday: 'Scale your sales today',
    maximizeRevenueToday: 'Maximize your revenue today',
    packageCountriesFeatureMonthly: 'Full access to SDeal & Sportdeal in the Netherlands and Belgium',
    packageCountriesFeatureYearly: 'Full access to SDeal & Sportdeal in all countries',
    packageA: 'Starter',
    packageASubtitle: 'Perfect for new and growing webshops',
    packageAFeature1: '€ 29,00 p.m. fixed',
    packageAFeature2: 'Full access to SDeal & Sportdeal in the Netherlands and Belgium',
    packageAFeature3: 'Commission from 15%, automatically reinvested to boost your sales',
    packageAFeature4: 'Get started quickly with powerful integrations',
    packageAFeature5: 'Advanced dashboard, reports & insights to optimize performance',
    packageB: 'Growth',
    packageBSubtitle: 'Built for scale, higher volumes and stronger margins',
    packageBMostPopular: 'Most popular',
    packageBFeature1: '€ 49,00 p.m. fixed',
    packageBFeature2: 'Full access to SDeal & Sportdeal in the Netherlands and Belgium',
    packageBFeature3: 'Commission from 8%, fully invested in growth marketing',
    packageBFeature4: 'Full control over pricing, margins and strategy',
    packageBFeature5: 'Scale faster with advanced integrations',
    packageBFeature6: 'In-depth dashboard, reports & insights',
    packageBFeature7: 'Repricer tool included',
    packageC: 'Pro',
    packageCSubtitle: 'Maximize your reach, control and revenue in NL & BE',
    packageCSubtitleMonthly: 'Maximize your reach, control and revenue in NL & BE',
    packageCSubtitleYearly: 'Maximize your reach, control and revenue in all countries',
    packageCFullPackage: 'Full package',
    packageCFeature1: '€ 99,- p.m. fixed',
    packageCFeature2: 'Set your own commission (min 8%) – fully reinvested into marketing',
    packageCFeature3: 'Repricer tool, automate pricing adjustments and stay competitive',
    packageCFeature4: 'Advanced dashboard & expert guidance, track and optimize performance',
    packageCFeature5: 'Access in the Netherlands and Belgium; all countries with a yearly package',
    packageCFeature6: 'FairifAI (Pro review tool), AI-powered review moderation',
    packageCFeature7: 'Productdeal.com CSS, save up to 20% on your own Google Shopping costs',
    packageCFeature8: 'Productdeal.com CSS (via SDeal) – Up to 20% discount on Google Shopping click costs',
    addonsTitle: 'ADD ONS',
    moreInfo: 'More info',
    addonFairifAI: 'FairifAI',
    addonFairifAIPrice: 'See pricing',
    addonDEALCSS: 'Productdeal.com CSS',
    addonDEALCSSPrice: '€24,95 and €14,95 p/m for SDeal platform customers',
    addonDEALCSSDescription: 'When an advertiser bids 1 euro per click via Google Shopping CSS, only 80 cents of that bid is allocated to the auction. However, with Productdeal.com CSS, 100% of your bid goes to the auction. This results in a 25% bid increase without extra bidding effort.',
    addonCPC: 'CPC (Cost per click)',
    addonCPCPrice: '€39,95 p/m',
    addonCPCDescription: 'CAAS (Clicks as a Service). With CAAS, sellers can place products that are not billed through SDeal, but lead directly to their own webshop. Instead of a commission per sale, they pay a fixed monthly amount for visibility and traffic via SDeal.',
    addonMagentoDevelopment: 'E-commerce Development',
    addonMagentoDevelopmentPrice: 'Contact for pricing',
    addonMagentoDevelopmentDescription: 'Professional e-commerce development services. Custom modules, integrations, maintenance, and optimization for your e-commerce platform.',
    addonOwnMagentoStore: 'Own Magento Store',
    addonOwnMagentoStorePrice: '€1,995 setup + €199 p/m',
    addonOwnMagentoStoreDescription: 'Complete Magento store solutions. From setup to customization, we help you build and maintain your own powerful e-commerce store.',
    
    // Package Selection Page
    packageHeroTitle: 'Choose your SDeal package',
    packageHeroSubtitle: 'Choose your package below – it takes less than 30 seconds and gets you ready to sell on SDeal.',
    packageWhyTitle: 'Why this update?',
    packageWhyText: 'SDeal started as a pure 3rd-party marketplace. We have noticed that the traditional commission model unintentionally creates disadvantages for sellers. When a higher commission is requested, margin pressure arises for the seller. This makes it more difficult to offer sharp consumer prices, and that has a direct effect on conversion, volume and competitiveness.\n\nBy switching to a hybrid marketplace + SaaS model where the commission is fully used as marketing budget and our revenue model is in the fixed package price, we prevent that margin pressure. Sellers thus retain more room to offer competitive prices, which ultimately leads to more sales and a healthier ecosystem for everyone.',
    packageChooseTitle: 'Choose your package',
    choosePackage: 'Choose',
    packageSelectA: 'Starter',
    packageAPrice: '€29 per month',
    packageADesc1: 'Standard commission (minimum 15%)',
    packageADesc2: 'Full access to the SDeal platform',
    packageADesc3: 'Automatic campaign management in NL & BE (all countries with a yearly package)',
    packageADesc4: 'Suitable for smaller to medium-sized assortments',
    packageSelectB: 'Growth',
    packageBPrice: '€49 per month',
    packageBDesc1: 'You determine your own commission (minimum 8%)',
    packageBDesc2: '100% of the commission is used as marketing budget',
    packageBDesc3: 'Full access to the SDeal platform',
    packageBDesc4: 'Ideal if you actively steer with price and margin',
    packageSelectC: 'Pro',
    packageCPrice: '€99 per month',
    packageCDesc1: 'Determine your own commission (minimum 8%)',
    packageCDesc2: 'Including access to Productdeal.com CSS',
    packageCDesc3: 'For maximum visibility and growth',
    packageCDesc4: 'Can be supplemented with CAAS (Clicks as a Service) to your own webshop',
    packageChangeNote: 'You can always adjust your package later in consultation if your situation changes.',
    packageSummaryTitle: 'Selected Package Summary',
    packageSummaryPackage: 'Package',
    packageSummarySellerId: 'Seller ID',
    packageSummaryStartDate: 'Start Date',
    packageSummaryCommission: 'Commission',
    packageSummaryBilling: 'Billing Period',
    packageSummaryTotal: 'Total Price',
    packageSummaryTotalPerMonth: 'per month',
    packageSummaryTotalPerYear: 'per year',
    packageAddonsTitle: 'Optional add-ons',
    paymentTitle: 'Payment',
    paymentTitlePlatformFee: 'Platform fee payment (subscription)',
    proceedToPayment: 'Proceed to Payment',
    proceedToMandatePayment: 'Confirm with €0.01 (SEPA mandate)',
    paymentPlatformFeeNote: 'This payment is the platform fee (your package subscription). Payouts for orders via our platform are separate and follow your chosen weekly or monthly frequency.',
    paymentMandatePromoNote: 'With your promo code you only pay €0.01 to set up a SEPA mandate — not the full package fee. Regular package billing starts after the free period (from 1 January according to the offer).',
    packageSummaryPromoCode: 'Promo code',
    packageSummaryFirstPayment: 'First payment now',
    packageSummaryMandateOnly: 'mandate verification only',
    packageSummaryRegularWouldBe: 'Regular package price',
    paymentSuccessTitle: 'Payment Successful!',
    paymentSuccessMessage: 'Your payment has been processed successfully. Your subscription is now active.',
    paymentSuccessDetails: 'You will receive a confirmation email with all the details. Thank you for choosing SDeal!',
    yearlyDiscount: '30% discount',
    sellerIdLabel: 'Seller ID',
    sellerIdPlaceholder: 'Enter your seller ID',
    sellerEmailLabel: 'Email Address',
    sellerEmailPlaceholder: 'Enter your email address',
    generalEmailLabel: 'General email address',
    generalEmailPlaceholder: 'Main contact email for your shop',
    financeEmailLabel: 'Finance email',
    financeEmailPlaceholder: 'Invoices and finance (optional)',
    orderEmailLabel: 'Orders email',
    orderEmailPlaceholder: 'Order notifications (optional)',
    sellerInfoTitle: 'Your Information',
    sellerInfoDescription: 'Please enter your email address and seller ID to continue',
    customerTypeTitle: 'Are you a new or existing customer?',
    customerTypeNew: 'New Customer',
    customerTypeNewDescription: 'I am not yet a customer at SDeal',
    customerTypeExisting: 'Existing Customer',
    customerTypeExistingDescription: 'I already have a seller ID',
    newCustomerTitle: 'Registration Details',
    newCustomerDescription: 'Fill in your contact details to register',
    companyNameLabel: 'Company Name',
    companyNamePlaceholder: 'Enter your company name',
    displayNameLabel: 'Display name',
    displayNamePlaceholder: 'How your shop appears on SDeal',
    displayNameHelp: 'This is the name customers see on SDeal (Magento shop name). Your company name above may be your legal trade name.',
    displayNameRequired: 'Display name is required',
    firstNameLabel: 'First Name',
    firstNamePlaceholder: 'Enter your first name',
    lastNameLabel: 'Last Name',
    lastNamePlaceholder: 'Enter your last name',
    streetLabel: 'Street and House Number',
    streetPlaceholder: 'e.g. Main Street 123',
    cityLabel: 'City',
    cityPlaceholder: 'Enter your city',
    postalCodeLabel: 'Postal Code',
    postalCodePlaceholder: 'e.g. 1234 AB',
    countryLabel: 'Country',
    countryPlaceholder: 'Select your country',
    phoneLabel: 'Phone Number',
    phonePlaceholder: 'e.g. +31 6 12345678',
    kvkNumberLabel: 'Chamber of Commerce Number',
    kvkNumberPlaceholder: 'e.g. 12345678',
    vatNumberLabel: 'VAT Number',
    vatNumberPlaceholder: 'e.g. NL123456789B01',
    ibanLabel: 'IBAN',
    ibanPlaceholder: 'e.g. NL91 ABNA 0417 1643 00',
    bicLabel: 'BIC',
    bicPlaceholder: 'e.g. ABNANL2A',
    countryNL: 'Netherlands',
    countryBE: 'Belgium',
    countryDE: 'Germany',
    countryFR: 'France',
    countryGB: 'United Kingdom',
    countryAT: 'Austria',
    countryIT: 'Italy',
    countryDK: 'Denmark',
    countrySE: 'Sweden',
    countryPL: 'Poland',
    countryES: 'Spain',
    countryCZ: 'Czech Republic',
    sellCountriesTitle: 'Countries you want to sell in',
    sellCountriesHint: 'The Netherlands and Belgium are always available. Extra countries require a yearly package because we provide translations for those markets.',
    sellCountriesBaseGroup: 'Always available',
    sellCountriesExtraGroup: 'Additional countries (yearly package required)',
    sellCountriesYearlyRequiredHint: 'For these countries we provide translations. That requires a yearly package as a minimum.',
    sellCountriesYearlyRequiredNotice: 'You selected one or more additional countries. A yearly package is required for translations in those markets. Monthly billing is disabled.',
    sellCountriesYearlyRequiredError: 'A yearly package is required when selling in countries other than the Netherlands and Belgium.',
    sellCountriesMonthlyDisabledNote: 'Not available with extra countries',
    payoutFrequencyTitle: 'Payout frequency for orders via our system',
    payoutFrequencyWeekly: 'Weekly',
    payoutFrequencyMonthly: 'Monthly',
    startDateTitle: 'Start Date',
    startDateImmediate: 'Immediate',
    startDate2026: 'January 1, 2026',
    commissionPercentageLabel: 'Commission Percentage',
    commissionPercentagePlaceholder: 'Enter percentage',
    commissionPercentageMinA: 'Minimum 15%',
    commissionPercentageMinBC: 'Minimum 8%',
    packageAddonDEALCSS: 'Productdeal.com CSS – Comparison Shopping Service – €24,95 p/m',
    packageAddonCAAS: 'CAAS – Clicks as a Service (CPC to your own webshop) – €39,95 p/m',
    packageAddonFairifAI: 'Review reputation management (Fairifai) – see fairifai.com for pricing',
    packageConfirmTitle: 'Confirm your agreement',
    packageConfirmText: 'The SDeal Seller Agreement 8.0 and the SDeal Seller Terms & Conditions 8.0 apply to your account. You can view these documents here:',
    packageAgreementLink: 'Download SDeal Seller Agreement 8.0',
    packageTermsLink: 'Download SDeal Seller Terms & Conditions 8.0',
    packageRegistrationLink: 'Download SDeal Seller Registration Form 8.0',
    packageAgreementCheckbox: 'I agree to the SDeal Seller Agreement 8.0 and the SDeal Seller Terms & Conditions 8.0, and confirm that these apply to my cooperation with SDeal.',
    packageLegalNote1: 'By choosing your package and agreeing, you continue under the current SDeal Seller Agreement and Terms & Conditions.',
    packageLegalNote2: 'If you sell via SDeal without completing this form, the SDeal Seller Agreement 8.0 and the SDeal Seller Terms & Conditions 8.0 still apply.',
    packageCTAButton: 'Confirm & continue',
    packageCTANote: 'After confirmation, you will receive an email with an overview of your chosen package and a copy of the documentation for your own administration.',
    packageFAQTitle: 'FAQ – Frequently asked questions',
    packageFAQ1Question: 'What happens if I don\'t make a choice?',
    packageFAQ1Answer: 'Your current agreement ends on December 31, 2025. We will contact you to align a suitable package. As long as you have not chosen a package, we may limit your marketing and platform support.',
    packageFAQ2Question: 'Do my existing prices or products change?',
    packageFAQ2Answer: 'No. You keep your products, prices and content. What changes is the way we structure the marketing budget and our compensation together.',
    packageFAQ3Question: 'Can I switch packages later?',
    packageFAQ3Answer: 'Yes, in consultation you can switch packages in the meantime if that better suits your volume or strategy.',
    
    // About
    ourMission: 'Our Mission',
    ourApproach: 'Our Approach',
    
    // Contact
    sales: 'Sales Team',
    contactIntro: 'Get in touch with our team. We\'re here to help you with any questions about SDeal or Fairifai.',
    scheduleCall: 'Schedule a Call',
    otherWays: 'Other Ways to Contact Us',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    
    // Connections
    connectionsIntro: 'SDeal offers seamless integrations with the most commonly used e-commerce systems. This allows sellers to quickly and easily connect their webshop, order handling, and product feeds to our platform.',
    
    // Partners
    partners: 'Our Partners',
    partnersIntro: 'SDeal collaborates with industry-leading partners to provide the best possible experience for our customers. These partnerships enable us to offer innovative solutions, enhanced security, and reliable services.',
         visitPartner: 'Visit Partner',
     interestedPartnership: 'Interested in Partnership?',
     partnershipDescription: 'Are you interested in becoming a partner with SDeal? We\'re always looking for innovative companies that share our vision of reliable and secure online shopping. Contact us to discuss partnership opportunities.',
     contactUs: 'Contact Us',
     contactForPartnership: 'Contact Us for Partnership Opportunities',
     
     // Jobs
     joinOurTeam: 'Join Our Team',
     jobsIntro: 'We are currently looking for top talents to join our fast-growing team. Discover opportunities that match your skills and ambitions.',
     fullTimePositions: 'Full-time Positions',
     traineeships: 'Traineeships',
     traineeshipIntro: 'We are regularly seeking young and motivated talent who are eager to further develop their skills in their field.',
     interestedInJoining: 'Interested in Joining Our Team?',
     contactUsJobs: 'Does one of the positions above suit you perfectly? Don\'t hesitate and contact us at',
     viewDetails: 'View Details',
     applyNow: 'Apply Now',
    keyResponsibilities: 'Key Responsibilities',
    requirements: 'Requirements',
    whatWeOffer: 'What We Offer',

    // Dashboard menu
    menuLabel: 'MENU',
    dashboard: 'Dashboard',
    dashboardProducts: 'Products',
    dashboardOrders: 'Orders',
    dashboardDisputes: 'Disputes',
    dashboardReturns: 'Returns',
    dashboardPerformance: 'Performance',
    dashboardFinance: 'Finance',
    dashboardPayout: 'Payout',
    dashboardInvoice: 'Invoice',
    dashboardSettings: 'Settings',
    dashboardFeed: 'Feed',
    dashboardFaq: 'FAQ',
    dashboardNews: 'News',

    dashboardTotalProductsLive: 'Total Products live',
    dashboardToProducts: 'To products',
    dashboardTotalProductsAdvertised: 'Total Products advertised',
    dashboardGood: 'Good',
    dashboardPreferredSeller: 'Preferred seller (SportDeal NL)',
    dashboardToPreferredSeller: 'To preferred seller >>',
    dashboardTotalRevenue: 'Total Revenue',
    dashboardMonthlyRevenue: 'Monthly Revenue',
    dashboardOrdersLabel: 'Orders',
    dashboardRevenue: 'Revenue',
    dashboardRevenuePerCountry: 'Revenue per country',
    dashboardLast12Months: 'Last 12 Months',
    dashboardNotPreferred: 'Not preferred',

    // Finance (Balance Management)
    financeTitle: 'Finance - Balance Management',
    balancePendingLabel: 'Balance Pending Seller (waiting for confirmation)',
    balanceConfirmedLabel: 'Balance Seller (confirmed)',
    balanceAvailableLabel: 'Balance Available Seller (ready for payment)',
    balanceRefundLabel: 'Balance Refund (available for refunds)',
    sellerReserveLabel: 'Seller Reserve (available for negative payouts)',
    addFundsButton: 'Add Funds',
    automaticPaymentsButton: 'Automatic Payments accepted',
    balanceNoteTitle: 'Balance Note',
    balanceNotePending: 'Balance (waiting for confirmation) is the balance that has not yet been confirmed.',
    balanceNoteConfirmed: 'Balance (Confirmed) is the balance that is waiting to be available.',
    balanceNoteAvailable: 'Balance Available is the balance available for next payment. This balance will top up every Thursday.',
    balanceNoteRefund: 'Balance refund is the amount you can use for refunding. If not sufficient please top up your balance.',
    balanceNoteReserve: 'Seller Reserve: A safety buffer to protect your account from chargebacks or cancellations. If your reserve falls below €0, please top up your balance to restore it.',
    financeLoading: 'Loading…',

    // Orders list
    ordersTitle: 'Orders',
    ordersStatus: 'Orders Status',
    ordersCompleted: 'Completed',
    ordersWaiting: 'Waiting',
    ordersCanceled: 'Canceled',
    downloadPdf: 'Download PDF',
    downloadCsv: 'CSV',
    orderDownloadList: 'Order Download List',
    recordsFound: 'records found',
    perPage: 'per page',
    ordersFilters: 'Filters',
    ordersColumns: 'Columns',
    ordersColProduct: 'Product Name',
    ordersColOrderId: 'Order ID',
    ordersColTotalCustomer: 'Total Amount Customer',
    ordersColOrderAmount: 'Order Amount',
    ordersColCustomer: 'Customer',
    ordersColCustomerOrderId: 'Customer Order Id',
    ordersColOrderStatus: 'Order Status',
    ordersColCommission: 'Commission',
    ordersColCreatedDate: 'Created Date',
    ordersColInternalStatus: 'Internal Status',
    ordersColFinanceStatus: 'Finance Status',
    ordersColPaypalDisputes: 'Paypal Disputes',
    ordersColView: 'View',
    orderStatusWaiting: 'Waiting for confirmation',
    orderStatusConfirmed: 'Confirmed',
    orderStatusCanceled: 'Canceled',
    orderStatusCompleted: 'Completed',
    financeStatusSettled: 'Settled',
    financeStatusPaid: 'Paid',
    financeStatusInvoiceAccepted: 'Invoice accepted',
    noDispute: 'No Dispute',
    ofPages: 'of',
    ordersEmpty: 'No orders',
    orderDetailTitle: 'Order',
    orderStatusLabel: 'Order Status',
    financeStatusLabel: 'Finance Status',
    orderDetailDownload: 'Download',
    orderDetailCsv: 'CSV',
    orderDetailPrintPacking: 'Print Packing Slips',
    orderCanceledBtn: 'Order Canceled',
    orderDate: 'Order Date',
    expectedArrivalDate: 'Expected Arrival Date',
    orderIdCustomer: 'Order ID Customer',
    totalAmountCustomer: 'Total Amount Customer',
    shippingName: 'Shipping Name',
    shippingAddress: 'Shipping Address',
    billingName: 'Billing Name',
    billingAddress: 'Billing Address',
    costPrice: 'Cost Price',
    deliveryCost: 'Delivery Cost',
    payout: 'Payout',
    paymentScheduledOn: 'Payment scheduled on',
    commission: 'Commission',
    contactCustomer: 'Contact Customer',
    orderStore: 'Order Store',
    backToOrders: 'Back to orders',
    'orderDetailN/A': 'N/A',
  },
  
  nl: {
    // Navigation
    about: 'Over ons',
    contact: 'Contact',
    connections: 'Verbindingen',
    faq: 'FAQ',
    
    // Home page
    welcome: 'Welkom bij SDeal',
    subtitle: 'Uw vertrouwde marktplaats in heel Europa',
    visitCountry: 'Bezoek SDeal',
    chooseCountry: 'Kies uw land',
    startSelling: 'Start met verkopen',
    aboutText: 'SDeal verbindt retailers en groothandelaren met consumenten door middel van hoogwaardige online marketing expertise. Ons IT-platform evolueert continu om onze partners te helpen hun verkopen te stimuleren en volledige controle te behouden over hun bestellingen en klantgegevens.',
    aboutText2: 'Anders dan grote e-commerce spelers die de volledige klantreis domineren en overnemen, geeft SDeal partners de mogelijkheid om te groeien terwijl ze de controle behouden. We bieden onafhankelijke ondersteuning en marketingkracht zonder uw concurrent te worden.',
    
    // Footer
    privacyPolicy: 'Privacybeleid',
    termsConditions: 'Algemene voorwaarden',
    jobs: 'Vacatures',
    
    // Language names
    english: 'Engels',
    dutch: 'Nederlands',
    german: 'Duits',
    french: 'Frans',
    
    // Products
    products: 'Onze Producten',
    productsIntro: 'Ontdek ons uitgebreide assortiment van producten en diensten die zijn ontworpen om uw bedrijf te helpen groeien.',
    catalogSearchTitle: 'Productcatalogus',
    catalogSearchPlaceholder: 'Zoek op naam of SKU (min. 2 tekens)',
    catalogSearchButton: 'Zoeken',
    catalogEmpty: 'Nog geen passende producten in onze catalogus.',
    catalogHint: 'Bekijk alle actieve producten of verfijn met zoeken.',
    catalogLoadError: 'Catalogus laden mislukt. Probeer het later opnieuw.',
    catalogViewOnShop: 'Bekijk',
    catalogLoading: 'Laden…',
    catalogOf: 'van',
    catalogPagination: 'Paginering',
    catalogPrevPage: 'Vorige pagina',
    catalogNextPage: 'Volgende pagina',
    catalogShow: 'Toon',
    catalogSortBy: 'Sorteer op',
    catalogSortPosition: 'Positie',
    catalogSortNameDesc: 'Naam Z–A',
    catalogSortPriceAsc: 'Prijs: laag naar hoog',
    catalogSortPriceDesc: 'Prijs: hoog naar laag',
    catalogViewMode: 'Weergave',
    catalogViewGrid: 'Raster',
    catalogViewList: 'Lijst',
    catalogType: 'Type',
    marketplace: 'Marktplaats Platform',
    marketplaceDesc: 'Geavanceerd e-commerce platform dat retailers en groothandelaren verbindt met consumenten in heel Europa.',
    marketplaceDetailed: 'SDeal Marketplace\n\nSDeal is een internationale marketplace waar sellers hun producten kunnen aanbieden aan consumenten in zeven Europese landen. Het platform combineert het bereik van een groot verkoopkanaal met slimme marketingautomatisering. Sellers krijgen volledige controle over hun prijzen, commissies en productaanbod, terwijl SDeal zorgt voor verkeer, advertenties en conversieoptimalisatie.\n\nDe kracht van SDeal ligt in de koppeling tussen performance-marketing en marktplaatsverkoop. Voor elk product wordt de ingestelde commissie rechtstreeks gebruikt om gericht verkeer aan te trekken, met name via Google Shopping. Scherpe prijzen en gewilde producten worden daardoor automatisch beloond met meer zichtbaarheid.\n\nSDeal biedt sellers daarnaast een repricer-tool en een uitgebreid dashboard om verkoopprestaties te volgen en prijzen te optimaliseren. Op die manier kunnen sellers concurreren op basis van prijs én performance, terwijl het platform de marketing verzorgt.\n\nWe bieden drie opties:\n\n1. Marketplace met vaste commissie\nBij een vaste commissie profiteer je van automatische marketing. SDeal zorgt voor verkeer, advertenties en conversieoptimalisatie.\n\n2. Marketplace met eigen ingestelde commissie\nBij een eigen ingestelde commissie profiteer je ook van automatische marketing. SDeal zorgt voor verkeer, advertenties en conversieoptimalisatie.\n\n3. CPC (CaaS)\nBij Clicks as a Service betaal je een vast maandbedrag voor zichtbaarheid en verkeer. Er wordt geen automatische marketing uitgevoerd.\n\nKortom: SDeal is een marketplace die niet alleen verkoopt, maar actief meegroeit met de prestaties van haar sellers, transparant, schaalbaar en volledig gericht op rendement.',
    dealCSS: 'Productdeal.com CSS',
    dealCSSDesc: 'Tot 20% korting op Google Shopping klikkosten. Wanneer je 1 euro per klik biedt, gaat 100% naar de veiling in plaats van 80%, wat resulteert in een 25% bodverhoging zonder extra inspanning.',
    dealCSSDetailed: 'Productdeal.com CSS\n\nMet Productdeal.com CSS biedt SDeal sellers de mogelijkheid om te adverteren via onze eigen Comparison Shopping Service (CSS), een door Google erkende vergelijkingsdienst.\n\nIn plaats van direct via Google Shopping te adverteren, loopt de advertentieweergave via Productdeal.com CSS. Dit is niet alleen volledig compatibel met je bestaande Merchant Center, maar levert ook direct voordeel op in de advertentieveilingen van Google.\n\nWat is een CSS?\n\nEen CSS (Comparison Shopping Service) is een onafhankelijke partij die namens webshops productadvertenties toont in Google Shopping. Sinds de Europese mededingingsregels verplichten dat Google zijn Shopping-ruimte deelt met externe aanbieders, kunnen sellers via een CSS goedkoper adverteren.\n\nWaarom kiezen voor Productdeal.com CSS\n\nTot 20% lagere klikprijzen (CPC)\nGoogle biedt een structurele korting aan op klikken die via een externe CSS worden gekocht. Sellers die adverteren via Productdeal.com CSS profiteren dus direct van lagere kosten per klik.\n\nMeer zichtbaarheid met hetzelfde budget\nDoor lagere klikprijzen kun je met hetzelfde advertentiebudget meer verkeer genereren of beter presteren in de veilingpositie van Google Shopping.\n\nWerkt onafhankelijk van SDeal\nProductdeal.com CSS werkt met je bestaande Merchant Center. Je huidige Merchant Center setup blijft volledig hetzelfde. Je profiteert alleen van de korting van Google op klikken die via een externe CSS worden gekocht.\n\nTransparant en schaalbaar\nJe behoudt inzicht in je prestaties en betaalt alleen de daadwerkelijke klik- of platformkosten, zonder verborgen commissies.\n\nSamengevat\n\nProductdeal.com CSS is de slimme manier om jouw producten via Google Shopping te adverteren, met lagere klikprijzen, hogere zichtbaarheid en zonder extra complexiteit.\n\nZie productdeal.com voor meer over Productdeal.com CSS.',
    productdealLinkSite: 'Productdeal.com',
    productdealLinkCss: 'Productdeal.com CSS',
    productdealLinkMore: 'Meer op Productdeal.com',
    cpc: 'CPC (Cost Per Click)',
    cpcDesc: 'CAAS (Clicks as a Service). Plaats producten die rechtstreeks leiden naar je eigen webshop. Betaal een vast maandbedrag voor zichtbaarheid en verkeer via SDeal in plaats van commissie per verkoop.',
    cpcDetailed: 'Clicks as a Service (CaaS)\n\nMet Clicks as a Service (CaaS) biedt SDeal sellers een nieuwe manier om zichtbaar te zijn op ons platform, zonder dat verkopen via SDeal zelf hoeven te verlopen.\n\nIn plaats van af te rekenen per verkoop, betaal je een vast maandbedrag voor zichtbaarheid en verkeer vanuit het SDeal-platform. Bezoekers die op jouw producten klikken, worden direct doorgestuurd naar je eigen webshop.\n\nCaaS is ideaal voor merken en retailers die hun eigen verkoopkanaal willen versterken, maar wel willen profiteren van het bereik, de productvergelijkingen en het verkeer van SDeal.\n\nWat het inhoudt\n\nVast maandbedrag, geen commissie\nJe betaalt één helder tarief per maand, onafhankelijk van omzet of aantal verkopen.\n\nVerkeer direct naar jouw webshop\nProductklikken leiden rechtstreeks naar jouw eigen site, zodat jij het klantcontact en de afhandeling behoudt.\n\nZichtbaarheid binnen het SDeal-ecosysteem\nJe producten verschijnen in relevante categorieën en zoekresultaten op het platform.\n\nGeen campagnes, wel bereik\nWij voeren geen advertenties voor deze producten, maar zorgen voor organische zichtbaarheid via het platform en onze feeds.\n\nSamengevat\n\nMet CaaS vergroot je de zichtbaarheid van je webshop via SDeal, zonder commissie per verkoop. Een eenvoudige, transparante manier om extra verkeer te genereren en je merk te versterken, tegen een vast maandbedrag.',
    reviewFairifAI: 'Review (FairifAI)',
    reviewFairifAIDesc: 'Review tool met AI als scheidsrechter. Verzamel reviews door klanten uit te nodigen om jouw bedrijf te beoordelen. AI modereert en beoordeelt alle reviews automatisch.',
    magentoDevelopment: 'E-commerce Development',
    magentoDevelopmentDesc: 'Professionele e-commerce ontwikkelingsdiensten. Aangepaste modules, integraties, onderhoud en optimalisatie voor jouw e-commerce platform.',
    magentoDevelopmentDetailed: 'E-commerce Development Service\n\nMet onze E-commerce Development Service helpen we sellers en merken bij het ontwikkelen, optimaliseren en onderhouden van hun webshop. Vanuit onze eigen ervaring met het SDeal-platform weten we precies wat er nodig is om schaalbaar, snel en conversiegericht te bouwen.\n\nWij werken niet met losse freelancers of anonieme bureaus, maar met een vast team van e-commerce specialisten dat dagelijks werkt aan performance, stabiliteit en koppelingen met feeds, marketplaces en advertentieplatformen.\n\nWat je krijgt\n\nE-commerce expertise uit de praktijk\nOns eigen platform draait op moderne e-commerce technologie, waardoor we weten wat er nodig is om succesvolle online stores te bouwen.\n\nVolledige projectbegeleiding\nIeder project wordt aangestuurd door een dedicated product owner, inbegrepen in het tarief.\n\nTransparante werkwijze\nWij rekenen een vast uurtarief van €75, inclusief product owner. Geen verborgen kosten, geen verrassingen.\n\nFlexibele inzet\nVan éénmalige optimalisaties tot structurele ontwikkeling of onderhoudscontracten.\n\nOndersteunde Platforms\n\nWij bieden ontwikkelingsdiensten voor de volgende e-commerce platforms:\n\n• Magento & Magento2\n• ACC (Adobe Commerce Cloud)\n• Shopify\n• Big-commerce\n• Drupal\n• Prestashop\n• Laravel\n• Lightspeed\n• WordPress Development\n\nVoor wie\n\nDeze service is bedoeld voor webshops die:\n\nhun bestaande e-commerce omgeving willen verbeteren of versnellen;\n\nnieuwe modules, koppelingen of design-updates nodig hebben;\n\nwillen profiteren van een ervaren technisch team zonder de overhead van een groot bureau.\n\nSamengevat\n\nMet SDeal E-commerce Development kies je voor een ervaren partner die e-commerce oplossingen niet alleen bouwt, maar er dagelijks mee leeft. Technisch sterk, commercieel slim en volledig transparant in kosten en uitvoering. Voor €75 per uur, inclusief product owner.',
    ownMagentoStore: 'Eigen Magento Store',
    ownMagentoStoreDesc: 'Complete Magento store oplossingen. Van opzet tot aanpassing, wij helpen je bij het bouwen en onderhouden van je eigen krachtige e-commerce store.',
    ownMagentoStoreDetailed: 'Eigen Magento Store\n\nWil je een professionele webshop zonder alles vanaf nul te hoeven bouwen? Met SDeal Magento Store bieden we een compleet ingerichte omgeving op basis van ons eigen platform, ontwikkeld en verfijnd over meerdere jaren.\n\nOnze infrastructuur is geoptimaliseerd voor snelheid, veiligheid en schaalbaarheid. Je profiteert direct van dezelfde stabiele basis waarop ook het SDeal-platform zelf draait, inclusief koppelingen met betaalproviders, verzenddiensten en productfeeds.\n\nWat je krijgt\n\nVolwaardige Magento 2-webshop\nGebouwd op een bewezen fundament met moderne thema\'s en optimale performance.\n\nHosting, onderhoud en updates inbegrepen\nWij zorgen voor beveiliging, stabiliteit en regelmatige optimalisaties.\n\nKoppeling met SDeal en externe marktplaatsen\nPubliceer eenvoudig producten naar meerdere verkoopkanalen vanuit één centrale omgeving.\n\nOndersteuning door ons developmentteam\nOns Magento-team staat klaar voor maatwerk en groei.\n\nKosten\n\nSetupkosten: €1.995 (eenmalig)\n\nMaandelijkse kosten: €299 per maand (inclusief hosting, onderhoud en support)\n\nSamengevat\n\nMet SDeal Magento Store beschik je over een krachtige, onderhoudsvrije Magento 2-webshop, gebaseerd op jarenlange praktijkervaring en dagelijks geoptimaliseerd voor performance en conversie. Jij richt je op verkopen, wij zorgen dat alles draait.',
    analytics: 'Analytics & Inzichten',
    analyticsDesc: 'Uitgebreide data analytics en business intelligence tools om uw verkoopprestaties te optimaliseren.',
    support: '24/7 Ondersteuning',
    supportDesc: 'Rond-de-klok klantenservice en technische ondersteuning voor al onze partners.',
    
    // Pricing
    pricingTitle: 'SDeal Pricing 2026',
    pricingDescription: 'Verhoog je webshopomzet met directe toegang tot meer dan 200 miljoen consumenten in Europa. Maandpakketten gaan live in NL & BE; met een jaarpakket openen we alle landen.',
    pricingSubtitle: 'Verhoog je webshopomzet met directe toegang tot meer dan 200 miljoen consumenten in Europa. Maandelijks: NL & BE. Jaarlijks: alle landen.',
    billingPeriod: 'Factureringsperiode',
    monthly: 'Maandelijks',
    yearly: 'Jaarlijks',
    yearlySave: 'Bespaar 25%',
    perMonth: 'maand',
    perYear: 'jaar',
    noSetupCosts: 'Geen opstartkosten',
    startSellingToday: 'Start vandaag met verkopen',
    scaleSalesToday: 'Schaal je verkoop vandaag',
    maximizeRevenueToday: 'Maximaliseer je omzet vandaag',
    packageCountriesFeatureMonthly: 'Volledige toegang tot SDeal & Sportdeal in Nederland en België',
    packageCountriesFeatureYearly: 'Volledige toegang tot SDeal & Sportdeal in alle landen',
    packageA: 'Starter',
    packageASubtitle: 'Perfect voor nieuwe en groeiende webshops',
    packageAFeature1: '€ 29,00 p.m. vast',
    packageAFeature2: 'Volledige toegang tot SDeal & Sportdeal in Nederland en België',
    packageAFeature3: 'Commissie vanaf 15%, automatisch herinvesteerd om je verkoop te stimuleren',
    packageAFeature4: 'Snel aan de slag met krachtige integraties',
    packageAFeature5: 'Uitgebreid dashboard, rapporten en inzichten om prestaties te optimaliseren',
    packageB: 'Growth',
    packageBSubtitle: 'Gebouwd voor schaal, hogere volumes en sterkere marges',
    packageBMostPopular: 'Meest populair',
    packageBFeature1: '€ 49,00 p.m. vast',
    packageBFeature2: 'Volledige toegang tot SDeal & Sportdeal in Nederland en België',
    packageBFeature3: 'Commissie vanaf 8%, volledig ingezet voor growth marketing',
    packageBFeature4: 'Volledige controle over prijzen, marges en strategie',
    packageBFeature5: 'Schaal sneller met geavanceerde integraties',
    packageBFeature6: 'Uitgebreid dashboard, rapporten en inzichten',
    packageBFeature7: 'Repricer tool inbegrepen',
    packageC: 'Pro',
    packageCSubtitle: 'Maximaliseer je bereik, controle en omzet in NL & BE',
    packageCSubtitleMonthly: 'Maximaliseer je bereik, controle en omzet in NL & BE',
    packageCSubtitleYearly: 'Maximaliseer je bereik, controle en omzet in alle landen',
    packageCFullPackage: 'Volledig pakket',
    packageCFeature1: '€ 99,- p.m. vast',
    packageCFeature2: 'Bepaal je eigen commissie (min. 8%) – volledig herinvesteerd in marketing',
    packageCFeature3: 'Repricer tool, automatiseer prijsaanpassingen en blijf concurrerend',
    packageCFeature4: 'Uitgebreid dashboard & expertbegeleiding, volg en optimaliseer prestaties',
    packageCFeature5: 'Toegang in Nederland en België; alle landen met een jaarpakket',
    packageCFeature6: 'FairifAI (Pro reviewtool), AI-gestuurde reviewmoderatie',
    packageCFeature7: 'Productdeal.com CSS, bespaar tot 20% op je eigen Google Shopping-kosten',
    packageCFeature8: 'Productdeal.com CSS (via SDeal) – Tot 20% korting op Google Shopping-klikkosten',
    addonsTitle: 'ADD ONS',
    moreInfo: 'Meer info',
    addonFairifAI: 'FairifAI',
    addonFairifAIPrice: 'Zie prijzen',
    addonDEALCSS: 'Productdeal.com CSS',
    addonDEALCSSPrice: '€24,95 en €14,95 p/m voor SDeal platform klanten',
    addonDEALCSSDescription: 'Wanneer een adverteerder 1 euro per klik biedt via Google Shopping CSS, wordt slechts 80 cent van dat bod toegewezen aan de veiling. Echter, met Productdeal.com CSS gaat 100% van je bod naar de veiling. Dit resulteert in een bodverhoging van 25% zonder extra biedinspanning.',
    addonCPC: 'CPC (Cost per click)',
    addonCPCPrice: '€39,95 p/m',
    addonCPCDescription: 'CAAS (Clicks as a Service). Met CAAS kunnen sellers producten plaatsen die niet via SDeal worden afgerekend, maar rechtstreeks leiden naar hun eigen webshop. In plaats van een commissie per verkoop betalen zij een vast maandbedrag voor zichtbaarheid en verkeer via SDeal.',
    addonMagentoDevelopment: 'E-commerce Development',
    addonMagentoDevelopmentPrice: 'Contact voor prijs',
    addonMagentoDevelopmentDescription: 'Professionele e-commerce ontwikkelingsdiensten. Aangepaste modules, integraties, onderhoud en optimalisatie voor jouw e-commerce platform.',
    addonOwnMagentoStore: 'Eigen Magento Store',
    addonOwnMagentoStorePrice: '€1.995 opstart + €199 p/m',
    addonOwnMagentoStoreDescription: 'Complete Magento store oplossingen. Van opzet tot aanpassing, wij helpen je bij het bouwen en onderhouden van je eigen krachtige e-commerce store.',
    
    // Package Selection Page
    packageHeroTitle: 'Kies jouw SDeal-pakket',
    packageHeroSubtitle: 'Kies hieronder je pakket – het kost minder dan 30 seconden en daarna kun je meteen aan de slag op SDeal.',
    packageWhyTitle: 'Waarom deze update?',
    packageWhyText: 'SDeal is gestart als een pure 3rd-party marketplace. We hebben gemerkt dat het traditionele commissiemodel onbedoeld nadelen oplevert voor sellers. Wanneer een hogere commissie wordt gevraagd, ontstaat er margedruk bij de seller. Daardoor wordt het moeilijker om scherpe consumentenprijzen aan te bieden, en dat heeft direct effect op conversie, volume en concurrentiekracht.\n\nDoor over te stappen naar een hybride marketplace + SaaS-model waarbij de commissie volledig wordt ingezet als marketingbudget en ons verdienmodel in de vaste pakketprijs zit, voorkomen we die margedruk. Sellers houden zo meer ruimte om concurrerende prijzen te bieden, wat uiteindelijk zorgt voor meer verkoop en een gezonder ecosysteem voor iedereen.',
    packageChooseTitle: 'Kies jouw pakket',
    choosePackage: 'Kies',
    packageSelectA: 'Starter',
    packageAPrice: '€29 per maand',
    packageADesc1: 'Standaard commissie (minimaal 15%)',
    packageADesc2: 'Volledige toegang tot het SDeal-platform',
    packageADesc3: 'Automatisch campagnebeheer in NL & BE (alle landen met een jaarpakket)',
    packageADesc4: 'Geschikt voor kleinere tot middelgrote assortiments',
    packageSelectB: 'Growth',
    packageBPrice: '€49 per maand',
    packageBDesc1: 'Je bepaalt zelf je commissie (minimaal 8%)',
    packageBDesc2: '100% van de commissie wordt ingezet als marketingbudget',
    packageBDesc3: 'Volledige toegang tot het SDeal-platform',
    packageBDesc4: 'Ideaal als je actief met prijs en marge stuurt',
    packageSelectC: 'Pro',
    packageCPrice: '€99 per maand',
    packageCDesc1: 'Zelf je commissie bepalen (minimaal 8%)',
    packageCDesc2: 'Inclusief toegang tot Productdeal.com CSS',
    packageCDesc3: 'Voor maximale zichtbaarheid en groei',
    packageCDesc4: 'Aan te vullen met CAAS (Clicks as a Service) naar je eigen webshop',
    packageChangeNote: 'Je kunt je pakket later altijd in overleg aanpassen als je situatie verandert.',
    packageSummaryTitle: 'Geselecteerd Pakket Overzicht',
    packageSummaryPackage: 'Pakket',
    packageSummarySellerId: 'Seller ID',
    packageSummaryStartDate: 'Startdatum',
    packageSummaryCommission: 'Commissie',
    packageSummaryBilling: 'Factureringsperiode',
    packageSummaryTotal: 'Totaalprijs',
    packageSummaryTotalPerMonth: 'per maand',
    packageSummaryTotalPerYear: 'per jaar',
    packageAddonsTitle: 'Optionele add-ons',
    paymentTitle: 'Betaling',
    paymentTitlePlatformFee: 'Betaling platformfee (abonnement)',
    proceedToPayment: 'Ga naar betaling',
    proceedToMandatePayment: 'Bevestig met €0,01 (SEPA-mandaat)',
    paymentPlatformFeeNote: 'Deze betaling is de platformfee (je pakketabonnement). Uitbetalingen voor orders via ons platform zijn apart en volgen je gekozen wekelijkse of maandelijkse frequentie.',
    paymentMandatePromoNote: 'Met je kortingscode betaal je alleen €0,01 om een SEPA-mandaat in te stellen — niet het volledige pakketbedrag. De normale pakketfacturatie start na de gratis periode (vanaf 1 januari volgens de actie).',
    packageSummaryPromoCode: 'Kortingscode',
    packageSummaryFirstPayment: 'Eerste betaling nu',
    packageSummaryMandateOnly: 'alleen mandaatverificatie',
    packageSummaryRegularWouldBe: 'Normale pakketprijs',
    paymentSuccessTitle: 'Betaling geslaagd!',
    paymentSuccessMessage: 'Je betaling is succesvol verwerkt. Je abonnement is nu actief.',
    paymentSuccessDetails: 'Je ontvangt een bevestigingsemail met alle details. Bedankt voor het kiezen van SDeal!',
    yearlyDiscount: '30% korting',
    sellerIdLabel: 'Seller ID',
    sellerIdPlaceholder: 'Voer je seller ID in',
    sellerEmailLabel: 'E-mailadres',
    sellerEmailPlaceholder: 'Voer je e-mailadres in',
    generalEmailLabel: 'Algemeen e-mailadres',
    generalEmailPlaceholder: 'Hoofdcontact e-mail voor je winkel',
    financeEmailLabel: 'Finance e-mail',
    financeEmailPlaceholder: 'Facturen en finance (optioneel)',
    orderEmailLabel: 'Order e-mailadres',
    orderEmailPlaceholder: 'Ordermeldingen (optioneel)',
    sellerInfoTitle: 'Jouw gegevens',
    sellerInfoDescription: 'Voer je e-mailadres en seller ID in om door te gaan',
    customerTypeTitle: 'Ben je een nieuwe of bestaande klant?',
    customerTypeNew: 'Nieuwe klant',
    customerTypeNewDescription: 'Ik ben nog geen klant bij SDeal',
    customerTypeExisting: 'Bestaande klant',
    customerTypeExistingDescription: 'Ik heb al een seller ID',
    newCustomerTitle: 'Registratie gegevens',
    newCustomerDescription: 'Vul je NAW gegevens in om te registreren',
    companyNameLabel: 'Bedrijfsnaam',
    companyNamePlaceholder: 'Voer je bedrijfsnaam in',
    displayNameLabel: 'Weergavenaam',
    displayNamePlaceholder: 'Naam van je winkel op SDeal',
    displayNameHelp: 'Zo kom je bij klanten op SDeal naar voren (Magento-winkelnaam). De bedrijfsnaam hierboven kan je officiële handelsnaam zijn.',
    displayNameRequired: 'Weergavenaam is verplicht',
    firstNameLabel: 'Voornaam',
    firstNamePlaceholder: 'Voer je voornaam in',
    lastNameLabel: 'Achternaam',
    lastNamePlaceholder: 'Voer je achternaam in',
    streetLabel: 'Straat en huisnummer',
    streetPlaceholder: 'Bijv. Hoofdstraat 123',
    cityLabel: 'Stad',
    cityPlaceholder: 'Voer je stad in',
    postalCodeLabel: 'Postcode',
    postalCodePlaceholder: 'Bijv. 1234 AB',
    countryLabel: 'Land',
    countryPlaceholder: 'Selecteer je land',
    phoneLabel: 'Telefoonnummer',
    phonePlaceholder: 'Bijv. +31 6 12345678',
    kvkNumberLabel: 'KVK nummer',
    kvkNumberPlaceholder: 'Bijv. 12345678',
    vatNumberLabel: 'BTW nummer',
    vatNumberPlaceholder: 'Bijv. NL123456789B01',
    ibanLabel: 'IBAN',
    ibanPlaceholder: 'Bijv. NL91 ABNA 0417 1643 00',
    bicLabel: 'BIC',
    bicPlaceholder: 'Bijv. ABNANL2A',
    countryNL: 'Nederland',
    countryBE: 'België',
    countryDE: 'Duitsland',
    countryFR: 'Frankrijk',
    countryGB: 'Verenigd Koninkrijk',
    countryAT: 'Oostenrijk',
    countryIT: 'Italië',
    countryDK: 'Denemarken',
    countrySE: 'Zweden',
    countryPL: 'Polen',
    countryES: 'Spanje',
    countryCZ: 'Tsjechië',
    sellCountriesTitle: 'Landen waar je wilt verkopen',
    sellCountriesHint: 'Nederland en België kun je altijd kiezen. Voor extra landen is een jaarpakket verplicht, omdat wij daarvoor de vertalingen verzorgen.',
    sellCountriesBaseGroup: 'Altijd beschikbaar',
    sellCountriesExtraGroup: 'Extra landen (jaarpakket verplicht)',
    sellCountriesYearlyRequiredHint: 'Voor deze landen verzorgen wij de vertalingen. Daarvoor is een jaarpakket het minimum.',
    sellCountriesYearlyRequiredNotice: 'Je hebt één of meer extra landen geselecteerd. Voor vertalingen in die markten is een jaarpakket verplicht. Maandelijks betalen is uitgeschakeld.',
    sellCountriesYearlyRequiredError: 'Bij verkoop in landen buiten Nederland en België is een jaarpakket verplicht.',
    sellCountriesMonthlyDisabledNote: 'Niet beschikbaar bij extra landen',
    payoutFrequencyTitle: 'Uitbetaling voor orders via ons systeem',
    payoutFrequencyWeekly: 'Wekelijks',
    payoutFrequencyMonthly: 'Maandelijks',
    startDateTitle: 'Startdatum',
    startDateImmediate: 'Per direct',
    startDate2026: '1 januari 2026',
    commissionPercentageLabel: 'Commissie Percentage',
    commissionPercentagePlaceholder: 'Voer percentage in',
    commissionPercentageMinA: 'Minimaal 15%',
    commissionPercentageMinBC: 'Minimaal 8%',
    packageAddonDEALCSS: 'Productdeal.com CSS – Comparison Shopping Service – €24,95 p/m',
    packageAddonCAAS: 'CAAS – Clicks as a Service (CPC naar je eigen webshop) – €39,95 p/m',
    packageAddonFairifAI: 'Review reputatiemanagement (Fairifai) – zie fairifai.com voor pricing',
    packageConfirmTitle: 'Bevestig je akkoord',
    packageConfirmText: 'Voor jouw account gelden het SDeal Seller Agreement 8.0 en de SDeal Seller Terms & Conditions 8.0. Je kunt deze documenten hier bekijken:',
    packageAgreementLink: 'Download SDeal Seller Agreement 8.0',
    packageTermsLink: 'Download SDeal Seller Terms & Conditions 8.0',
    packageRegistrationLink: 'Download SDeal Seller Registration Form 8.0',
    packageAgreementCheckbox: 'Ik ga akkoord met het SDeal Seller Agreement 8.0 en de SDeal Seller Terms & Conditions 8.0, en bevestig dat deze gelden voor mijn samenwerking met SDeal.',
    packageLegalNote1: 'Door je pakket te kiezen en akkoord te gaan, werk je verder onder het huidige SDeal Seller Agreement en de Seller Terms & Conditions.',
    packageLegalNote2: 'Als je via SDeal verkoopt zonder dit formulier in te vullen, gelden alsnog het SDeal Seller Agreement 8.0 en de SDeal Seller Terms & Conditions 8.0.',
    packageCTAButton: 'Bevestigen & doorgaan',
    packageCTANote: 'Na bevestiging ontvang je een e-mail met een overzicht van je gekozen pakket en een kopie van de documentatie voor je eigen administratie.',
    packageFAQTitle: 'FAQ – veelgestelde vragen',
    packageFAQ1Question: 'Wat gebeurt er als ik geen keuze maak?',
    packageFAQ1Answer: 'Je huidige overeenkomst eindigt op 31 december 2025. We nemen contact met je op om een passend pakket af te stemmen. Zolang je geen pakket hebt gekozen, kunnen we je marketing- en platformondersteuning mogelijk beperken.',
    packageFAQ2Question: 'Veranderen mijn bestaande prijzen of producten?',
    packageFAQ2Answer: 'Nee. Je behoudt je producten, prijzen en content. Wat verandert, is de manier waarop we samen het marketingbudget en onze vergoeding structureren.',
    packageFAQ3Question: 'Kan ik later nog van pakket wisselen?',
    packageFAQ3Answer: 'Ja, in overleg kun je tussentijds van pakket veranderen als dat beter past bij je volume of strategie.',
    
    // About
    ourMission: 'Onze Missie',
    ourApproach: 'Onze Aanpak',
    
    // Contact
    sales: 'Sales Team',
    contactIntro: 'Neem contact op met ons team. We staan klaar om u te helpen met vragen over SDeal of Fairifai.',
    scheduleCall: 'Gesprek Inplannen',
    otherWays: 'Andere Manieren om Contact op te Nemen',
    email: 'E-mail',
    phone: 'Telefoon',
    address: 'Adres',
    
    // Connections
    connectionsIntro: 'SDeal biedt naadloze integraties met de meest gebruikte e-commerce systemen. Dit maakt het mogelijk voor verkopers om snel en gemakkelijk hun webshop, orderverwerking en product feeds te verbinden met onze platform.',
    
    // Partners
    partners: 'Onze Partners',
    partnersIntro: 'SDeal samenwerkt met leidende industrie-partners om de beste ervaring te bieden voor onze klanten. Deze samenwerkingen maken het ons mogelijk om innovatieve oplossingen aan te bieden, een verbeterde beveiliging en betrouwbare diensten te bieden.',
         visitPartner: 'Partner Bezoeken',
     interestedPartnership: 'Interesse in Partnerschap?',
     partnershipDescription: 'Ben je geïnteresseerd in een partnerschap met SDeal? We zoeken altijd innovatieve bedrijven die onze visie delen van betrouwbare en veilige online winkelen. Neem contact met ons op om samenwerkingstaken te bespreken.',
     contactUs: 'Neem Contact Op',
     contactForPartnership: 'Neem Contact Op voor Partner Mogelijkheden',
     
     // Jobs
     joinOurTeam: 'Word Lid van Ons Team',
     jobsIntro: 'We zijn momenteel op zoek naar top talenten om ons snelgroeiende team te versterken. Ontdek kansen die passen bij jouw vaardigheden en ambities.',
     fullTimePositions: 'Volledige Tijd Posities',
     traineeships: 'Traineeships',
     traineeshipIntro: 'We zijn regelmatig op zoek naar jong en gemotiveerd talent dat graag hun vaardigheden in hun vakgebied verder willen ontwikkelen.',
     interestedInJoining: 'Interesse in Ons Team?',
     contactUsJobs: 'Past een van de bovenstaande functies perfect bij jou? Aarzel niet en neem contact met ons op via',
     viewDetails: 'Bekijk Details',
     applyNow: 'Solliciteer Nu',
     keyResponsibilities: 'Belangrijkste Verantwoordelijkheden',
     requirements: 'Vereisten',
     whatWeOffer: 'Wat Wij Bieden',

    // Dashboard menu
    menuLabel: 'MENU',
    dashboard: 'Dashboard',
    dashboardProducts: 'Producten',
    dashboardOrders: 'Orders',
    dashboardDisputes: 'Geschillen',
    dashboardReturns: 'Retourzendingen',
    dashboardPerformance: 'Prestaties',
    dashboardFinance: 'Financiën',
    dashboardPayout: 'Uitbetaling',
    dashboardInvoice: 'Factuur',
    dashboardSettings: 'Instellingen',
    dashboardFeed: 'Feed',
    dashboardFaq: 'FAQ',
    dashboardNews: 'Nieuws',

    dashboardTotalProductsLive: 'Totaal producten live',
    dashboardToProducts: 'Naar producten',
    dashboardTotalProductsAdvertised: 'Totaal producten geadverteerd',
    dashboardGood: 'Goed',
    dashboardPreferredSeller: 'Voorkeursverkoper (SportDeal NL)',
    dashboardToPreferredSeller: 'Naar voorkeursverkoper >>',
    dashboardTotalRevenue: 'Totale omzet',
    dashboardMonthlyRevenue: 'Maandomzet',
    dashboardOrdersLabel: 'Orders',
    dashboardRevenue: 'Omzet',
    dashboardRevenuePerCountry: 'Omzet per land',
    dashboardLast12Months: 'Laatste 12 maanden',
    dashboardNotPreferred: 'Niet voorkeur',

    // Finance (Balance Management)
    financeTitle: 'Financiën - Saldobeheer',
    balancePendingLabel: 'Saldo in behandeling (wacht op bevestiging)',
    balanceConfirmedLabel: 'Saldo verkoper (bevestigd)',
    balanceAvailableLabel: 'Saldo beschikbaar (klaar voor uitbetaling)',
    balanceRefundLabel: 'Terugbetalingssaldo (beschikbaar voor refunds)',
    sellerReserveLabel: 'Verkoperreserve (beschikbaar voor negatieve uitbetalingen)',
    addFundsButton: 'Geld toevoegen',
    automaticPaymentsButton: 'Automatische betalingen geaccepteerd',
    balanceNoteTitle: 'Saldonotitie',
    balanceNotePending: 'Saldo (wacht op bevestiging) is het saldo dat nog niet is bevestigd.',
    balanceNoteConfirmed: 'Saldo (bevestigd) is het saldo dat wacht op beschikbaarheid.',
    balanceNoteAvailable: 'Beschikbaar saldo is het saldo voor de volgende uitbetaling. Dit saldo wordt elke donderdag bijgevuld.',
    balanceNoteRefund: 'Terugbetalingssaldo is het bedrag dat u kunt gebruiken voor refunds. Bij onvoldoende saldo kunt u bijstorten.',
    balanceNoteReserve: 'Verkoperreserve: een buffer om uw account te beschermen bij chargebacks of annuleringen. Als uw reserve onder €0 komt, stort dan bij om deze te herstellen.',
    financeLoading: 'Laden…',

    // Orders list
    ordersTitle: 'Orders',
    ordersStatus: 'Orderstatus',
    ordersCompleted: 'Voltooid',
    ordersWaiting: 'In wachtrij',
    ordersCanceled: 'Geannuleerd',
    downloadPdf: 'Download PDF',
    downloadCsv: 'CSV',
    orderDownloadList: 'Orderdownloadlijst',
    recordsFound: 'resultaten',
    perPage: 'per pagina',
    ordersFilters: 'Filters',
    ordersColumns: 'Kolommen',
    ordersColProduct: 'Productnaam',
    ordersColOrderId: 'Order-ID',
    ordersColTotalCustomer: 'Totaalbedrag klant',
    ordersColOrderAmount: 'Orderbedrag',
    ordersColCustomer: 'Klant',
    ordersColCustomerOrderId: 'Klantorder-ID',
    ordersColOrderStatus: 'Orderstatus',
    ordersColCommission: 'Commissie',
    ordersColCreatedDate: 'Aanmaakdatum',
    ordersColInternalStatus: 'Interne status',
    ordersColFinanceStatus: 'Financiële status',
    ordersColPaypalDisputes: 'Paypal geschillen',
    ordersColView: 'Bekijken',
    orderStatusWaiting: 'Wacht op bevestiging',
    orderStatusConfirmed: 'Bevestigd',
    orderStatusCanceled: 'Geannuleerd',
    orderStatusCompleted: 'Voltooid',
    financeStatusSettled: 'Afgewikkeld',
    financeStatusPaid: 'Betaald',
    financeStatusInvoiceAccepted: 'Factuur geaccepteerd',
    noDispute: 'Geen geschil',
    ofPages: 'van',
    ordersEmpty: 'Geen orders',
    orderDetailTitle: 'Order',
    orderStatusLabel: 'Orderstatus',
    financeStatusLabel: 'Financiële status',
    orderDetailDownload: 'Download',
    orderDetailCsv: 'CSV',
    orderDetailPrintPacking: 'Pakbonnen afdrukken',
    orderCanceledBtn: 'Order geannuleerd',
    orderDate: 'Orderdatum',
    expectedArrivalDate: 'Verwachte aankomstdatum',
    orderIdCustomer: 'Order-ID klant',
    totalAmountCustomer: 'Totaalbedrag klant',
    shippingName: 'Verzendnaam',
    shippingAddress: 'Verzendadres',
    billingName: 'Facturatie naam',
    billingAddress: 'Facturatieadres',
    costPrice: 'Kostprijs',
    deliveryCost: 'Verzendkosten',
    payout: 'Uitbetaling',
    paymentScheduledOn: 'Betaling gepland op',
    commission: 'Commissie',
    contactCustomer: 'Contact klant',
    orderStore: 'Order store',
    backToOrders: 'Terug naar orders',
    'orderDetailN/A': 'N.v.t.',
  },
  
  de: {
    // Navigation
    about: 'Über uns',
    contact: 'Kontakt',
    connections: 'Verbindungen',
    faq: 'FAQ',
    
    // Home page
    welcome: 'Willkommen bei SDeal',
    subtitle: 'Ihr vertrauenswürdiger Marktplatz in ganz Europa',
    visitCountry: 'SDeal besuchen',
    chooseCountry: 'Wählen Sie Ihr Land',
    startSelling: 'Verkaufen starten',
    aboutText: 'SDeal verbindet Einzelhändler und Großhändler mit Verbrauchern durch hochwertige Online-Marketing-Expertise. Unsere IT-Plattform entwickelt sich kontinuierlich weiter, um unseren Partnern zu helfen, ihre Verkäufe zu steigern und die vollständige Kontrolle über ihre Bestellungen und Kundendaten zu behalten.',
    aboutText2: 'Anders als große E-Commerce-Akteure, die die gesamte Customer Journey dominieren und übernehmen, befähigt SDeal Partner zum Wachstum, während sie die Kontrolle behalten. Wir bieten unabhängige Unterstützung und Marketingkraft ohne Ihr Konkurrent zu werden.',
    
    // Footer
    privacyPolicy: 'Datenschutz',
    termsConditions: 'Allgemeine Geschäftsbedingungen',
    jobs: 'Stellenangebote',
    
    // Language names
    english: 'Englisch',
    dutch: 'Niederländisch',
    german: 'Deutsch',
    french: 'Französisch',
    
    // Products
    products: 'Unsere Produkte',
    productsIntro: 'Entdecken Sie unser umfassendes Sortiment an Produkten und Dienstleistungen, die darauf ausgelegt sind, Ihr Unternehmen beim Wachstum zu unterstützen.',
    catalogSearchTitle: 'Produktkatalog',
    catalogSearchPlaceholder: 'Suche nach Name oder SKU (mind. 2 Zeichen)',
    catalogSearchButton: 'Suchen',
    catalogEmpty: 'Noch keine passenden Produkte in unserem Katalog.',
    catalogHint: 'Alle aktiven Produkte anzeigen oder mit Suche eingrenzen.',
    catalogLoadError: 'Katalog konnte nicht geladen werden. Bitte später erneut versuchen.',
    catalogUnauthorized: 'Sitzung abgelaufen oder kein Zugriff. Bitte erneut als Administrator anmelden.',
    catalogViewOnShop: 'Ansehen',
    catalogLoading: 'Wird geladen…',
    catalogOf: 'von',
    catalogPagination: 'Seiten',
    catalogPrevPage: 'Vorherige Seite',
    catalogNextPage: 'Nächste Seite',
    catalogShow: 'Anzeigen',
    catalogSortBy: 'Sortieren nach',
    catalogSortPosition: 'Name A–Z',
    catalogSortNameDesc: 'Name Z–A',
    catalogSortPriceAsc: 'Preis: aufsteigend',
    catalogSortPriceDesc: 'Preis: absteigend',
    catalogViewMode: 'Ansicht',
    catalogViewGrid: 'Raster',
    catalogViewList: 'Liste',
    catalogType: 'Typ',
    marketplace: 'Marktplatz-Plattform',
    marketplaceDesc: 'Fortschrittliche E-Commerce-Plattform, die Einzelhändler und Großhändler mit Verbrauchern in ganz Europa verbindet.',
    marketplaceDetailed: 'SDeal Marketplace\n\nSDeal ist eine internationale Marktplatz, auf der Verkäufer ihre Produkte an Verbraucher in sieben europäischen Ländern anbieten können. Die Plattform kombiniert die Reichweite eines großen Vertriebskanals mit intelligenter Marketing-Automatisierung. Verkäufer erhalten vollständige Kontrolle über ihre Preise, Provisionen und Produktangebote, während SDeal für Traffic, Werbung und Konversionsoptimierung sorgt.\n\nDie Stärke von SDeal liegt in der Verbindung zwischen Performance-Marketing und Marktplatzverkauf. Für jedes Produkt wird die festgelegte Provision direkt verwendet, um gezielten Traffic anzuziehen, insbesondere über Google Shopping. Wettbewerbsfähige Preise und gefragte Produkte werden daher automatisch mit mehr Sichtbarkeit belohnt.\n\nSDeal bietet Verkäufern außerdem ein Repricer-Tool und ein umfassendes Dashboard zur Verfolgung der Verkaufsleistung und Preisoptimierung. Auf diese Weise können Verkäufer sowohl in Bezug auf Preis als auch auf Leistung konkurrieren, während die Plattform Marketing übernimmt.\n\nWir bieten drei Optionen:\n\n1. Marktplatz mit fester Provision\nBei einer festen Provision profitieren Sie von automatischem Marketing. SDeal sorgt für Traffic, Werbung und Konversionsoptimierung.\n\n2. Marktplatz mit selbst festgelegter Provision\nBei einer selbst festgelegten Provision profitieren Sie ebenfalls von automatischem Marketing. SDeal sorgt für Traffic, Werbung und Konversionsoptimierung.\n\n3. CPC (CaaS)\nBei Clicks as a Service zahlen Sie einen festen Monatsbetrag für Sichtbarkeit und Traffic. Es wird kein automatisches Marketing durchgeführt.\n\nKurz gesagt: SDeal ist eine Marktplatz, die nicht nur verkauft, sondern aktiv mit der Leistung ihrer Verkäufer wächst, transparent, skalierbar und vollständig auf Rendite ausgerichtet.',
    dealCSS: 'Productdeal.com CSS',
    dealCSSDesc: 'Bis zu 20% Rabatt auf Google Shopping-Klickkosten. Wenn Sie 1 Euro pro Klick bieten, gehen 100% an die Auktion statt 80%, was zu einer Gebotserhöhung von 25% ohne zusätzlichen Aufwand führt.',
    dealCSSDetailed: 'Productdeal.com CSS\n\nMit Productdeal.com CSS bietet SDeal Verkäufern die Möglichkeit, über unseren eigenen Comparison Shopping Service (CSS) zu werben, einen von Google anerkannten Vergleichsdienst.\n\nAnstatt direkt über Google Shopping zu werben, läuft die Anzeigendarstellung über Productdeal.com CSS. Dies ist nicht nur vollständig kompatibel mit Ihrem bestehenden Merchant Center, sondern bringt auch direkte Vorteile bei Googles Anzeigenauktionen.\n\nWas ist ein CSS?\n\nEin CSS (Comparison Shopping Service) ist eine unabhängige Partei, die im Auftrag von Webshops Produktanzeigen in Google Shopping anzeigt. Seit die europäischen Wettbewerbsregeln verlangen, dass Google seinen Shopping-Bereich mit externen Anbietern teilt, können Verkäufer über ein CSS günstiger werben.\n\nWarum Productdeal.com CSS wählen\n\nBis zu 20% niedrigere Klickpreise (CPC)\nGoogle bietet einen strukturellen Rabatt auf Klicks, die über einen externen CSS gekauft werden. Verkäufer, die über Productdeal.com CSS werben, profitieren daher direkt von niedrigeren Kosten pro Klick.\n\nMehr Sichtbarkeit mit dem gleichen Budget\nDurch niedrigere Klickpreise können Sie mit dem gleichen Werbebudget mehr Traffic generieren oder besser in der Auktionsposition von Google Shopping abschneiden.\n\nFunktioniert unabhängig von SDeal\nProductdeal.com CSS funktioniert mit Ihrem bestehenden Merchant Center. Ihre aktuelle Merchant Center-Einrichtung bleibt genau gleich. Sie profitieren nur von Googles Rabatt auf Klicks, die über einen externen CSS gekauft werden.\n\nTransparent und skalierbar\nSie behalten Einblick in Ihre Leistung und zahlen nur die tatsächlichen Klick- oder Plattformkosten, ohne versteckte Provisionen.\n\nZusammenfassend\n\nProductdeal.com CSS ist die intelligente Art, Ihre Produkte über Google Shopping zu bewerben, mit niedrigeren Klickpreisen, höherer Sichtbarkeit und ohne zusätzliche Komplexität.\n\nMehr zu Productdeal.com CSS auf productdeal.com.',
    productdealLinkSite: 'Productdeal.com',
    productdealLinkCss: 'Productdeal.com CSS',
    productdealLinkMore: 'Mehr auf Productdeal.com',
    cpc: 'CPC (Cost Per Click)',
    cpcDesc: 'CAAS (Clicks as a Service). Platzieren Sie Produkte, die direkt zu Ihrem eigenen Webshop führen. Zahlen Sie einen festen Monatsbetrag für Sichtbarkeit und Traffic über SDeal anstelle einer Provision pro Verkauf.',
    cpcDetailed: 'Clicks as a Service (CaaS)\n\nMit Clicks as a Service (CaaS) bietet SDeal Verkäufern eine neue Möglichkeit, auf unserer Plattform sichtbar zu sein, ohne dass Verkäufe über SDeal selbst abgewickelt werden müssen.\n\nAnstatt pro Verkauf abzurechnen, zahlen Sie einen festen Monatsbetrag für Sichtbarkeit und Traffic von der SDeal-Plattform. Besucher, die auf Ihre Produkte klicken, werden direkt zu Ihrem eigenen Webshop weitergeleitet.\n\nCaaS ist ideal für Marken und Einzelhändler, die ihren eigenen Vertriebskanal stärken möchten, aber auch von der Reichweite, den Produktvergleichen und dem Traffic von SDeal profitieren möchten.\n\nWas es beinhaltet\n\nFester Monatsbetrag, keine Provision\nSie zahlen einen klaren Tarif pro Monat, unabhängig vom Umsatz oder der Anzahl der Verkäufe.\n\nTraffic direkt zu Ihrem Webshop\nProduktklicks führen direkt zu Ihrer eigenen Website, sodass Sie den Kundenkontakt und die Abwicklung behalten.\n\nSichtbarkeit im SDeal-Ökosystem\nIhre Produkte erscheinen in relevanten Kategorien und Suchergebnissen auf der Plattform.\n\nKeine Kampagnen, aber Reichweite\nWir führen keine Anzeigen für diese Produkte, sorgen aber für organische Sichtbarkeit über die Plattform und unsere Feeds.\n\nZusammenfassend\n\nMit CaaS erhöhen Sie die Sichtbarkeit Ihres Webshops über SDeal, ohne Provision pro Verkauf. Eine einfache, transparente Möglichkeit, zusätzlichen Traffic zu generieren und Ihre Marke zu stärken, für einen festen Monatsbetrag.',
    reviewFairifAI: 'Review (FairifAI)',
    reviewFairifAIDesc: 'Bewertungstool mit KI als Schiedsrichter. Sammeln Sie Bewertungen, indem Sie Kunden einladen, Ihr Unternehmen zu bewerten. KI moderiert und bewertet alle Bewertungen automatisch.',
    magentoDevelopment: 'E-Commerce Entwicklung',
    magentoDevelopmentDesc: 'Professionelle E-Commerce-Entwicklungsdienste. Benutzerdefinierte Module, Integrationen, Wartung und Optimierung für Ihre E-Commerce-Plattform.',
    magentoDevelopmentDetailed: 'E-Commerce Development Service\n\nMit unserem E-Commerce Development Service helfen wir Verkäufern und Marken bei der Entwicklung, Optimierung und Wartung ihres Webshops. Basierend auf unserer eigenen Erfahrung mit der SDeal-Plattform wissen wir genau, was benötigt wird, um skalierbar, schnell und conversionsorientierte E-Commerce-Lösungen zu bauen.\n\nWir arbeiten nicht mit losen Freelancern oder anonymen Agenturen, sondern mit einem festen Team von E-Commerce-Spezialisten, die täglich an Performance, Stabilität und Integrationen mit Feeds, Marktplätzen und Werbeplattformen arbeiten.\n\nWas Sie bekommen\n\nE-Commerce-Expertise aus der Praxis\nUnsere eigene Plattform läuft auf moderner E-Commerce-Technologie, daher wissen wir, was es braucht, um erfolgreiche Online-Shops zu bauen.\n\nVollständige Projektbetreuung\nJedes Projekt wird von einem dedizierten Product Owner geleitet, im Tarif inbegriffen.\n\nTransparente Arbeitsweise\nWir berechnen einen festen Stundensatz von €75, inklusive Product Owner. Keine versteckten Kosten, keine Überraschungen.\n\nFlexibler Einsatz\nVon einmaligen Optimierungen bis hin zu struktureller Entwicklung oder Wartungsverträgen.\n\nUnterstützte Plattformen\n\nWir bieten Entwicklungsdienste für die folgenden E-Commerce-Plattformen:\n\n• Magento & Magento2\n• ACC (Adobe Commerce Cloud)\n• Shopify\n• Big-commerce\n• Drupal\n• Prestashop\n• Laravel\n• Lightspeed\n• WordPress Development\n\nFür wen\n\nDieser Service richtet sich an Webshops, die:\n\nihre bestehende E-Commerce-Umgebung verbessern oder beschleunigen möchten;\n\nneue Module, Integrationen oder Design-Updates benötigen;\n\nvon einem erfahrenen technischen Team profitieren möchten, ohne den Overhead einer großen Agentur.\n\nZusammenfassend\n\nMit SDeal E-Commerce Development wählen Sie einen erfahrenen Partner, der E-Commerce-Lösungen nicht nur baut, sondern täglich damit lebt. Technisch stark, kommerziell clever und vollständig transparent in Kosten und Ausführung. Für €75 pro Stunde, inklusive Product Owner.',
    ownMagentoStore: 'Eigener Magento Store',
    ownMagentoStoreDesc: 'Komplette Magento Store-Lösungen. Von der Einrichtung bis zur Anpassung helfen wir Ihnen beim Aufbau und der Wartung Ihres eigenen leistungsstarken E-Commerce-Stores.',
    ownMagentoStoreDetailed: 'Eigener Magento Store\n\nMöchten Sie einen professionellen Webshop, ohne alles von Grund auf bauen zu müssen? Mit SDeal Magento Store bieten wir eine komplett eingerichtete Umgebung basierend auf unserer eigenen Plattform, entwickelt und verfeinert über mehrere Jahre.\n\nUnsere Infrastruktur ist optimiert für Geschwindigkeit, Sicherheit und Skalierbarkeit. Sie profitieren direkt von der gleichen stabilen Basis, auf der auch die SDeal-Plattform selbst läuft, einschließlich Integrationen mit Zahlungsanbietern, Versanddiensten und Produktfeeds.\n\nWas Sie bekommen\n\nVollwertiger Magento 2 Webshop\nGebaut auf einem bewährten Fundament mit modernen Themes und optimaler Performance.\n\nHosting, Wartung und Updates inbegriffen\nWir kümmern uns um Sicherheit, Stabilität und regelmäßige Optimierungen.\n\nIntegration mit SDeal und externen Marktplätzen\nVeröffentlichen Sie einfach Produkte auf mehreren Vertriebskanälen aus einer zentralen Umgebung.\n\nUnterstützung durch unser Entwicklungsteam\nUnser Magento-Team steht bereit für maßgeschneiderte Lösungen und Wachstum.\n\nKosten\n\nEinrichtungskosten: €1.995 (einmalig)\n\nMonatliche Kosten: €299 pro Monat (inklusive Hosting, Wartung und Support)\n\nZusammenfassend\n\nMit SDeal Magento Store verfügen Sie über einen leistungsstarken, wartungsfreien Magento 2 Webshop, basierend auf jahrelanger praktischer Erfahrung und täglich optimiert für Performance und Conversion. Sie konzentrieren sich auf den Verkauf, wir sorgen dafür, dass alles läuft.',
    analytics: 'Analytics & Einblicke',
    analyticsDesc: 'Umfassende Datenanalyse und Business-Intelligence-Tools zur Optimierung Ihrer Verkaufsleistung.',
    support: '24/7 Support',
    supportDesc: 'Rund-um-die-Uhr-Kundenservice und technische Unterstützung für alle unsere Partner.',
    
    // Pricing
    pricingTitle: 'SDeal Pricing 2026',
    pricingDescription: 'Steigern Sie Ihren Webshop-Umsatz mit direktem Zugang zu über 200 Millionen Verbrauchern in Europa. Monatspakete gehen in NL & BE live; mit einem Jahresabo öffnen wir alle Länder.',
    pricingSubtitle: 'Steigern Sie Ihren Webshop-Umsatz mit direktem Zugang zu über 200 Millionen Verbrauchern in Europa. Monatlich: NL & BE. Jährlich: alle Länder.',
    billingPeriod: 'Abrechnungszeitraum',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    yearlySave: '25% sparen',
    perMonth: 'Monat',
    perYear: 'Jahr',
    noSetupCosts: 'Keine Einrichtungskosten',
    startSellingToday: 'Starten Sie noch heute mit dem Verkauf',
    scaleSalesToday: 'Skalieren Sie Ihren Verkauf noch heute',
    maximizeRevenueToday: 'Maximieren Sie Ihren Umsatz noch heute',
    packageCountriesFeatureMonthly: 'Voller Zugang zu SDeal & Sportdeal in den Niederlanden und Belgien',
    packageCountriesFeatureYearly: 'Voller Zugang zu SDeal & Sportdeal in allen Ländern',
    packageA: 'Starter',
    packageASubtitle: 'Perfekt für neue und wachsende Webshops',
    packageAFeature1: '€ 29,00 p.m. fest',
    packageAFeature2: 'Voller Zugang zu SDeal & Sportdeal in den Niederlanden und Belgien',
    packageAFeature3: 'Provision ab 15%, automatisch reinvestiert zur Steigerung Ihres Umsatzes',
    packageAFeature4: 'Schnell loslegen mit leistungsstarken Integrationen',
    packageAFeature5: 'Erweitertes Dashboard, Berichte & Einblicke zur Leistungsoptimierung',
    packageB: 'Growth',
    packageBSubtitle: 'Konzipiert für Skalierung, höhere Volumen und stärkere Margen',
    packageBMostPopular: 'Am beliebtesten',
    packageBFeature1: '€ 49,00 p.m. fest',
    packageBFeature2: 'Voller Zugang zu SDeal & Sportdeal in den Niederlanden und Belgien',
    packageBFeature3: 'Provision ab 8%, vollständig in Growth-Marketing investiert',
    packageBFeature4: 'Volle Kontrolle über Preise, Margen und Strategie',
    packageBFeature5: 'Schneller skalieren mit erweiterten Integrationen',
    packageBFeature6: 'Detailliertes Dashboard, Berichte & Einblicke',
    packageBFeature7: 'Repricer-Tool inklusive',
    packageC: 'Pro',
    packageCSubtitle: 'Maximieren Sie Reichweite, Kontrolle und Umsatz in NL & BE',
    packageCSubtitleMonthly: 'Maximieren Sie Reichweite, Kontrolle und Umsatz in NL & BE',
    packageCSubtitleYearly: 'Maximieren Sie Reichweite, Kontrolle und Umsatz in allen Ländern',
    packageCFullPackage: 'Vollständiges Paket',
    packageCFeature1: '€ 99,- p.m. fest',
    packageCFeature2: 'Eigene Provision (min. 8%) – vollständig in Marketing reinvestiert',
    packageCFeature3: 'Repricer-Tool, Preisanpassungen automatisieren und wettbewerbsfähig bleiben',
    packageCFeature4: 'Erweitertes Dashboard & Expertenberatung, Leistung verfolgen und optimieren',
    packageCFeature5: 'Zugang in den Niederlanden und Belgien; alle Länder mit Jahresabo',
    packageCFeature6: 'FairifAI (Pro-Bewertungstool), KI-gestützte Bewertungsmoderation',
    packageCFeature7: 'Productdeal.com CSS, sparen Sie bis zu 20% bei Ihren Google Shopping-Kosten',
    packageCFeature8: 'Productdeal.com CSS (über SDeal) – Bis zu 20% Rabatt auf Google Shopping-Klickkosten',
    addonsTitle: 'ADD ONS',
    moreInfo: 'Mehr Info',
    addonFairifAI: 'FairifAI',
    addonFairifAIPrice: 'Siehe Preise',
    addonDEALCSS: 'Productdeal.com CSS',
    addonDEALCSSPrice: '€24,95 und €14,95 p.m. für SDeal Plattform-Kunden',
    addonDEALCSSDescription: 'Wenn ein Werbetreibender 1 Euro pro Klick über Google Shopping CSS bietet, werden nur 80 Cent dieses Gebots der Auktion zugewiesen. Bei Productdeal.com CSS geht jedoch 100% Ihres Gebots an die Auktion. Dies führt zu einer Gebotserhöhung von 25% ohne zusätzlichen Gebotsaufwand.',
    addonCPC: 'CPC (Cost per click)',
    addonCPCPrice: '€39,95 p.m.',
    addonCPCDescription: 'CAAS (Clicks as a Service). Mit CAAS können Verkäufer Produkte platzieren, die nicht über SDeal abgerechnet werden, sondern direkt zu ihrem eigenen Webshop führen. Anstelle einer Provision pro Verkauf zahlen sie einen festen Monatsbetrag für Sichtbarkeit und Traffic über SDeal.',
    addonMagentoDevelopment: 'E-Commerce Entwicklung',
    addonMagentoDevelopmentPrice: 'Preis auf Anfrage',
    addonMagentoDevelopmentDescription: 'Professionelle E-Commerce-Entwicklungsdienste. Benutzerdefinierte Module, Integrationen, Wartung und Optimierung für Ihre E-Commerce-Plattform.',
    addonOwnMagentoStore: 'Eigener Magento Store',
    addonOwnMagentoStorePrice: '€1.995 Einrichtung + €199 p.m.',
    addonOwnMagentoStoreDescription: 'Komplette Magento Store-Lösungen. Von der Einrichtung bis zur Anpassung helfen wir Ihnen beim Aufbau und der Wartung Ihres eigenen leistungsstarken E-Commerce-Stores.',
    
    // Package Selection Page
    packageHeroTitle: 'Wählen Sie Ihr SDeal-Paket',
    packageHeroSubtitle: 'Wählen Sie unten Ihr Paket – es dauert weniger als 30 Sekunden und danach können Sie direkt auf SDeal verkaufen.',
    packageWhyTitle: 'Warum dieses Update?',
    packageWhyText: 'SDeal startete als reiner 3rd-Party-Marketplace. Wir haben festgestellt, dass das traditionelle Provisionsmodell unbeabsichtigt Nachteile für Verkäufer schafft. Wenn eine höhere Provision verlangt wird, entsteht Margendruck beim Verkäufer. Dadurch wird es schwieriger, scharfe Verbraucherpreise anzubieten, und das hat direkte Auswirkungen auf Conversion, Volumen und Wettbewerbsfähigkeit.\n\nDurch den Wechsel zu einem hybriden Marketplace + SaaS-Modell, bei dem die Provision vollständig als Marketingbudget verwendet wird und unser Umsatzmodell im festen Paketpreis liegt, verhindern wir diesen Margendruck. Verkäufer behalten so mehr Spielraum, um wettbewerbsfähige Preise anzubieten, was letztendlich zu mehr Verkäufen und einem gesünderen Ökosystem für alle führt.',
    packageChooseTitle: 'Wählen Sie Ihr Paket',
    choosePackage: 'Wählen',
    packageSelectA: 'Starter',
    packageAPrice: '€29 pro Monat',
    packageADesc1: 'Standard-Provision (mindestens 15%)',
    packageADesc2: 'Vollzugang zur SDeal-Plattform',
    packageADesc3: 'Automatisches Kampagnenmanagement in NL & BE (alle Länder mit Jahresabo)',
    packageADesc4: 'Geeignet für kleinere bis mittlere Sortimente',
    packageSelectB: 'Growth',
    packageBPrice: '€49 pro Monat',
    packageBDesc1: 'Sie bestimmen Ihre eigene Provision (mindestens 8%)',
    packageBDesc2: '100% der Provision wird als Marketingbudget eingesetzt',
    packageBDesc3: 'Vollzugang zur SDeal-Plattform',
    packageBDesc4: 'Ideal, wenn Sie aktiv mit Preis und Marge steuern',
    packageSelectC: 'Pro',
    packageCPrice: '€99 pro Monat',
    packageCDesc1: 'Bestimmen Sie Ihre eigene Provision (mindestens 8%)',
    packageCDesc2: 'Inklusive Zugang zu Productdeal.com CSS',
    packageCDesc3: 'Für maximale Sichtbarkeit und Wachstum',
    packageCDesc4: 'Kann mit CAAS (Clicks as a Service) zu Ihrem eigenen Webshop ergänzt werden',
    packageChangeNote: 'Sie können Ihr Paket später jederzeit in Absprache anpassen, wenn sich Ihre Situation ändert.',
    packageSummaryTitle: 'Ausgewähltes Paket Zusammenfassung',
    packageSummaryPackage: 'Paket',
    packageSummarySellerId: 'Verkäufer-ID',
    packageSummaryStartDate: 'Startdatum',
    packageSummaryCommission: 'Provision',
    packageSummaryBilling: 'Abrechnungszeitraum',
    packageSummaryTotal: 'Gesamtpreis',
    packageSummaryTotalPerMonth: 'pro Monat',
    packageSummaryTotalPerYear: 'pro Jahr',
    packageAddonsTitle: 'Optionale Add-ons',
    paymentTitle: 'Zahlung',
    paymentTitlePlatformFee: 'Plattformgebühr (Abonnement)',
    proceedToPayment: 'Zur Zahlung',
    proceedToMandatePayment: 'Mit €0,01 bestätigen (SEPA-Mandat)',
    paymentPlatformFeeNote: 'Diese Zahlung ist die Plattformgebühr (Ihr Paket-Abonnement). Auszahlungen für Bestellungen über unsere Plattform sind getrennt und folgen Ihrer gewählten wöchentlichen oder monatlichen Frequenz.',
    paymentMandatePromoNote: 'Mit Ihrem Aktionscode zahlen Sie nur €0,01 zur Einrichtung eines SEPA-Mandats — nicht die volle Paketgebühr. Die reguläre Paketabrechnung beginnt nach der Gratisperiode (ab 1. Januar laut Angebot).',
    packageSummaryPromoCode: 'Aktionscode',
    packageSummaryFirstPayment: 'Erste Zahlung jetzt',
    packageSummaryMandateOnly: 'nur Mandatsverifizierung',
    packageSummaryRegularWouldBe: 'Regulärer Paketpreis',
    paymentSuccessTitle: 'Zahlung erfolgreich!',
    paymentSuccessMessage: 'Ihre Zahlung wurde erfolgreich verarbeitet. Ihr Abonnement ist jetzt aktiv.',
    paymentSuccessDetails: 'Sie erhalten eine Bestätigungs-E-Mail mit allen Details. Vielen Dank, dass Sie SDeal gewählt haben!',
    yearlyDiscount: '30% Rabatt',
    sellerIdLabel: 'Verkäufer-ID',
    sellerIdPlaceholder: 'Geben Sie Ihre Verkäufer-ID ein',
    sellerEmailLabel: 'E-Mail-Adresse',
    sellerEmailPlaceholder: 'Geben Sie Ihre E-Mail-Adresse ein',
    generalEmailLabel: 'Allgemeine E-Mail-Adresse',
    generalEmailPlaceholder: 'Hauptkontakt-E-Mail für Ihren Shop',
    financeEmailLabel: 'Finance E-Mail',
    financeEmailPlaceholder: 'Rechnungen und Finance (optional)',
    orderEmailLabel: 'Bestell-E-Mail',
    orderEmailPlaceholder: 'Bestellbenachrichtigungen (optional)',
    sellerInfoTitle: 'Ihre Informationen',
    sellerInfoDescription: 'Bitte geben Sie Ihre E-Mail-Adresse und Verkäufer-ID ein, um fortzufahren',
    customerTypeTitle: 'Sind Sie ein neuer oder bestehender Kunde?',
    customerTypeNew: 'Neuer Kunde',
    customerTypeNewDescription: 'Ich bin noch kein Kunde bei SDeal',
    customerTypeExisting: 'Bestehender Kunde',
    customerTypeExistingDescription: 'Ich habe bereits eine Verkäufer-ID',
    newCustomerTitle: 'Registrierungsdaten',
    newCustomerDescription: 'Füllen Sie Ihre Kontaktdaten aus, um sich zu registrieren',
    companyNameLabel: 'Firmenname',
    companyNamePlaceholder: 'Geben Sie Ihren Firmennamen ein',
    displayNameLabel: 'Anzeigename',
    displayNamePlaceholder: 'Name Ihres Shops auf SDeal',
    displayNameHelp: 'So erscheinen Sie Kunden auf SDeal (Magento-Shopname). Der Firmenname kann Ihr offizieller Name sein.',
    displayNameRequired: 'Anzeigename ist erforderlich',
    firstNameLabel: 'Vorname',
    firstNamePlaceholder: 'Geben Sie Ihren Vornamen ein',
    lastNameLabel: 'Nachname',
    lastNamePlaceholder: 'Geben Sie Ihren Nachnamen ein',
    streetLabel: 'Straße und Hausnummer',
    streetPlaceholder: 'z.B. Hauptstraße 123',
    cityLabel: 'Stadt',
    cityPlaceholder: 'Geben Sie Ihre Stadt ein',
    postalCodeLabel: 'Postleitzahl',
    postalCodePlaceholder: 'z.B. 12345',
    countryLabel: 'Land',
    countryPlaceholder: 'Wählen Sie Ihr Land',
    phoneLabel: 'Telefonnummer',
    phonePlaceholder: 'z.B. +49 30 12345678',
    kvkNumberLabel: 'Handelsregisternummer',
    kvkNumberPlaceholder: 'z.B. HRB 12345',
    vatNumberLabel: 'Umsatzsteuer-ID',
    vatNumberPlaceholder: 'z.B. DE123456789',
    ibanLabel: 'IBAN',
    ibanPlaceholder: 'z.B. DE89 3704 0044 0532 0130 00',
    bicLabel: 'BIC',
    bicPlaceholder: 'z.B. COBADEFFXXX',
    countryNL: 'Niederlande',
    countryBE: 'Belgien',
    countryDE: 'Deutschland',
    countryFR: 'Frankreich',
    countryGB: 'Vereinigtes Königreich',
    countryAT: 'Österreich',
    countryIT: 'Italien',
    countryDK: 'Dänemark',
    countrySE: 'Schweden',
    countryPL: 'Polen',
    countryES: 'Spanien',
    countryCZ: 'Tschechien',
    sellCountriesTitle: 'Länder, in denen Sie verkaufen möchten',
    sellCountriesHint: 'Niederlande und Belgien sind immer wählbar. Weitere Länder erfordern ein Jahresabo, weil wir für diese Märkte die Übersetzungen bereitstellen.',
    sellCountriesBaseGroup: 'Immer verfügbar',
    sellCountriesExtraGroup: 'Weitere Länder (Jahresabo erforderlich)',
    sellCountriesYearlyRequiredHint: 'Für diese Länder stellen wir Übersetzungen bereit. Dafür ist ein Jahresabo das Minimum.',
    sellCountriesYearlyRequiredNotice: 'Sie haben ein oder mehrere zusätzliche Länder ausgewählt. Für Übersetzungen in diesen Märkten ist ein Jahresabo erforderlich. Monatliche Zahlung ist deaktiviert.',
    sellCountriesYearlyRequiredError: 'Beim Verkauf in Ländern außerhalb der Niederlande und Belgiens ist ein Jahresabo erforderlich.',
    sellCountriesMonthlyDisabledNote: 'Nicht verfügbar bei zusätzlichen Ländern',
    payoutFrequencyTitle: 'Auszahlungshäufigkeit für Bestellungen über unser System',
    payoutFrequencyWeekly: 'Wöchentlich',
    payoutFrequencyMonthly: 'Monatlich',
    startDateTitle: 'Startdatum',
    startDateImmediate: 'Sofort',
    startDate2026: '1. Januar 2026',
    commissionPercentageLabel: 'Provision Prozentsatz',
    commissionPercentagePlaceholder: 'Prozentsatz eingeben',
    commissionPercentageMinA: 'Mindestens 15%',
    commissionPercentageMinBC: 'Mindestens 8%',
    packageAddonDEALCSS: 'Productdeal.com CSS – Comparison Shopping Service – €24,95 p.m.',
    packageAddonCAAS: 'CAAS – Clicks as a Service (CPC zu Ihrem eigenen Webshop) – €39,95 p.m.',
    packageAddonFairifAI: 'Review Reputationsmanagement (Fairifai) – siehe fairifai.com für Preise',
    packageConfirmTitle: 'Bestätigen Sie Ihre Vereinbarung',
    packageConfirmText: 'Für Ihr Konto gelten das SDeal Seller Agreement 8.0 und die SDeal Seller Terms & Conditions 8.0. Sie können diese Dokumente hier einsehen:',
    packageAgreementLink: 'SDeal Seller Agreement 8.0 herunterladen',
    packageTermsLink: 'SDeal Seller Terms & Conditions 8.0 herunterladen',
    packageRegistrationLink: 'SDeal Seller Registration Form 8.0 herunterladen',
    packageAgreementCheckbox: 'Ich stimme dem SDeal Seller Agreement 8.0 und den SDeal Seller Terms & Conditions 8.0 zu und bestätige, dass diese für meine Zusammenarbeit mit SDeal gelten.',
    packageLegalNote1: 'Indem Sie Ihr Paket wählen und zustimmen, arbeiten Sie weiter unter dem aktuellen SDeal Seller Agreement und den Seller Terms & Conditions.',
    packageLegalNote2: 'Wenn Sie über SDeal verkaufen, ohne dieses Formular auszufüllen, gelten dennoch das SDeal Seller Agreement 8.0 und die SDeal Seller Terms & Conditions 8.0.',
    packageCTAButton: 'Bestätigen & fortfahren',
    packageCTANote: 'Nach der Bestätigung erhalten Sie eine E-Mail mit einer Übersicht über Ihr gewähltes Paket und eine Kopie der Dokumentation für Ihre eigene Verwaltung.',
    packageFAQTitle: 'FAQ – häufig gestellte Fragen',
    packageFAQ1Question: 'Was passiert, wenn ich keine Wahl treffe?',
    packageFAQ1Answer: 'Ihr aktueller Vertrag endet am 31. Dezember 2025. Wir werden Sie kontaktieren, um ein passendes Paket abzustimmen. Solange Sie kein Paket gewählt haben, können wir Ihre Marketing- und Plattformunterstützung möglicherweise einschränken.',
    packageFAQ2Question: 'Ändern sich meine bestehenden Preise oder Produkte?',
    packageFAQ2Answer: 'Nein. Sie behalten Ihre Produkte, Preise und Inhalte. Was sich ändert, ist die Art und Weise, wie wir gemeinsam das Marketingbudget und unsere Vergütung strukturieren.',
    packageFAQ3Question: 'Kann ich später noch das Paket wechseln?',
    packageFAQ3Answer: 'Ja, in Absprache können Sie zwischendurch das Paket wechseln, wenn das besser zu Ihrem Volumen oder Ihrer Strategie passt.',
    
    // About
    ourMission: 'Unsere Mission',
    ourApproach: 'Unser Ansatz',
    
    // Contact
    sales: 'Vertriebsteam',
    contactIntro: 'Kontaktieren Sie unser Team. Wir sind hier, um Ihnen bei Fragen zu SDeal oder Fairifai zu helfen.',
    scheduleCall: 'Anruf Planen',
    otherWays: 'Andere Kontaktmöglichkeiten',
    email: 'E-Mail',
    phone: 'Telefon',
    address: 'Adresse',
    
    // Connections
    connectionsIntro: 'SDeal bietet nahtlose Integrationen mit den am häufigsten verwendeten E-Commerce-Systemen. Dies ermöglicht es Verkäufern, ihre Webshop, Bestellverarbeitung und Produktfeeds schnell und einfach mit unserer Plattform zu verbinden.',
    
    // Partners
    partners: 'Unsere Partner',
    partnersIntro: 'SDeal arbeitet mit führenden Branchenpartnern zusammen, um die beste Erfahrung für unsere Kunden zu bieten. Diese Partnerschaften ermöglichen es uns, innovative Lösungen anzubieten, eine verbesserte Sicherheit und zuverlässige Dienste anzubieten.',
         visitPartner: 'Partner Besuchen',
     interestedPartnership: 'Interessiert an einem Partnerschaft?',
     partnershipDescription: 'Sind Sie an einem Partnerschaft mit SDeal interessiert? Wir suchen ständig innovativen Unternehmen, die unsere Vision von zuverlässigem und sicheren Online-Einkauf teilen. Wenden Sie sich an uns, um Partnerschaftsfragen zu besprechen.',
     contactUs: 'Kontaktieren Sie uns',
     contactForPartnership: 'Kontaktieren Sie uns für Partner-Möglichkeiten',
     
     // Jobs
     joinOurTeam: 'Werden Sie Teil Unseres Teams',
     jobsIntro: 'Wir suchen derzeit nach Top-Talenten, um unser schnell wachsendes Team zu verstärken. Entdecken Sie Möglichkeiten, die zu Ihren Fähigkeiten und Ambitionen passen.',
     fullTimePositions: 'Vollzeit-Positionen',
     traineeships: 'Traineeships',
     traineeshipIntro: 'Wir suchen regelmäßig nach jungen und motivierten Talenten, die ihre Fähigkeiten in ihrem Fachgebiet weiterentwickeln möchten.',
     interestedInJoining: 'Interesse an Unserem Team?',
     contactUsJobs: 'Passt eine der oben genannten Positionen perfekt zu Ihnen? Zögern Sie nicht und kontaktieren Sie uns unter',
     viewDetails: 'Details Anzeigen',
     applyNow: 'Jetzt Bewerben',
     keyResponsibilities: 'Wichtige Verantwortlichkeiten',
     requirements: 'Anforderungen',
     whatWeOffer: 'Was Wir Bieten',

    // Dashboard menu
    menuLabel: 'MENÜ',
    dashboard: 'Dashboard',
    dashboardProducts: 'Produkte',
    dashboardOrders: 'Bestellungen',
    dashboardDisputes: 'Streitigkeiten',
    dashboardReturns: 'Retouren',
    dashboardPerformance: 'Leistung',
    dashboardFinance: 'Finanzen',
    dashboardPayout: 'Auszahlung',
    dashboardInvoice: 'Rechnung',
    dashboardSettings: 'Einstellungen',
    dashboardFeed: 'Feed',
    dashboardFaq: 'FAQ',
    dashboardNews: 'Neuigkeiten',

    dashboardTotalProductsLive: 'Produkte live gesamt',
    dashboardToProducts: 'Zu Produkten',
    dashboardTotalProductsAdvertised: 'Beworbene Produkte gesamt',
    dashboardGood: 'Gut',
    dashboardPreferredSeller: 'Bevorzugter Verkäufer (SportDeal NL)',
    dashboardToPreferredSeller: 'Zum bevorzugten Verkäufer >>',
    dashboardTotalRevenue: 'Gesamtumsatz',
    dashboardMonthlyRevenue: 'Monatsumsatz',
    dashboardOrdersLabel: 'Bestellungen',
    dashboardRevenue: 'Umsatz',
    dashboardRevenuePerCountry: 'Umsatz pro Land',
    dashboardLast12Months: 'Letzte 12 Monate',
    dashboardNotPreferred: 'Nicht bevorzugt',

    // Finance (Balance Management)
    financeTitle: 'Finanzen - Saldenverwaltung',
    balancePendingLabel: 'Saldo ausstehend (wartet auf Bestätigung)',
    balanceConfirmedLabel: 'Verkäufer-Saldo (bestätigt)',
    balanceAvailableLabel: 'Verfügbares Saldo (bereit für Auszahlung)',
    balanceRefundLabel: 'Rückerstattungssaldo (für Rückerstattungen)',
    sellerReserveLabel: 'Verkäuferreserve (für negative Auszahlungen)',
    addFundsButton: 'Geld aufladen',
    automaticPaymentsButton: 'Automatische Zahlungen akzeptiert',
    balanceNoteTitle: 'Saldo-Hinweis',
    balanceNotePending: 'Saldo (wartet auf Bestätigung) ist das noch nicht bestätigte Saldo.',
    balanceNoteConfirmed: 'Saldo (bestätigt) ist das Saldo, das auf Verfügbarkeit wartet.',
    balanceNoteAvailable: 'Verfügbares Saldo ist das Saldo für die nächste Auszahlung. Es wird jeden Donnerstag aufgefüllt.',
    balanceNoteRefund: 'Rückerstattungssaldo ist der Betrag für Rückerstattungen. Bitte laden Sie bei Bedarf auf.',
    balanceNoteReserve: 'Verkäuferreserve: Ein Puffer zum Schutz vor Chargebacks oder Stornierungen. Unter €0 bitte aufladen.',
    financeLoading: 'Laden…',

    // Orders list
    ordersTitle: 'Bestellungen',
    ordersStatus: 'Bestellstatus',
    ordersCompleted: 'Abgeschlossen',
    ordersWaiting: 'Wartend',
    ordersCanceled: 'Storniert',
    downloadPdf: 'PDF herunterladen',
    downloadCsv: 'CSV',
    orderDownloadList: 'Bestellliste herunterladen',
    recordsFound: 'Einträge gefunden',
    perPage: 'pro Seite',
    ordersFilters: 'Filter',
    ordersColumns: 'Spalten',
    ordersColProduct: 'Produktname',
    ordersColOrderId: 'Bestell-ID',
    ordersColTotalCustomer: 'Gesamtbetrag Kunde',
    ordersColOrderAmount: 'Bestellbetrag',
    ordersColCustomer: 'Kunde',
    ordersColCustomerOrderId: 'Kundenbestell-ID',
    ordersColOrderStatus: 'Bestellstatus',
    ordersColCommission: 'Provision',
    ordersColCreatedDate: 'Erstellungsdatum',
    ordersColInternalStatus: 'Interner Status',
    ordersColFinanceStatus: 'Finanzstatus',
    ordersColPaypalDisputes: 'Paypal-Streitigkeiten',
    ordersColView: 'Ansehen',
    orderStatusWaiting: 'Warte auf Bestätigung',
    orderStatusConfirmed: 'Bestätigt',
    orderStatusCanceled: 'Storniert',
    orderStatusCompleted: 'Abgeschlossen',
    financeStatusSettled: 'Abgewickelt',
    financeStatusPaid: 'Bezahlt',
    financeStatusInvoiceAccepted: 'Rechnung akzeptiert',
    noDispute: 'Kein Streit',
    ofPages: 'von',
    ordersEmpty: 'Keine Bestellungen',
    orderDetailTitle: 'Bestellung',
    orderStatusLabel: 'Bestellstatus',
    financeStatusLabel: 'Finanzstatus',
    orderDetailDownload: 'Download',
    orderDetailCsv: 'CSV',
    orderDetailPrintPacking: 'Lieferscheine drucken',
    orderCanceledBtn: 'Bestellung storniert',
    orderDate: 'Bestelldatum',
    expectedArrivalDate: 'Voraussichtliches Ankunftsdatum',
    orderIdCustomer: 'Kunden-Bestell-ID',
    totalAmountCustomer: 'Gesamtbetrag Kunde',
    shippingName: 'Versandname',
    shippingAddress: 'Versandadresse',
    billingName: 'Rechnungsname',
    billingAddress: 'Rechnungsadresse',
    costPrice: 'Einkaufspreis',
    deliveryCost: 'Lieferkosten',
    payout: 'Auszahlung',
    paymentScheduledOn: 'Zahlung geplant am',
    commission: 'Provision',
    contactCustomer: 'Kundenkontakt',
    orderStore: 'Bestellstore',
    backToOrders: 'Zurück zu Bestellungen',
    'orderDetailN/A': 'k. A.',
  },
  
  fr: {
    // Navigation
    about: 'À propos',
    contact: 'Contact',
    connections: 'Connexions',
    faq: 'FAQ',
    
    // Home page
    welcome: 'Bienvenue chez SDeal',
    subtitle: 'Votre place de marché de confiance à travers l\'Europe',
    visitCountry: 'Visiter SDeal',
    chooseCountry: 'Choisissez votre pays',
    startSelling: 'Commencer à vendre',
    aboutText: 'SDeal connecte les détaillants et les grossistes avec les consommateurs grâce à une expertise marketing en ligne de haute qualité. Notre plateforme informatique évolue continuellement pour aider nos partenaires à stimuler leurs ventes et maintenir un contrôle total sur leurs commandes et données clients.',
    aboutText2: 'Contrairement aux grands acteurs du e-commerce qui dominent et prennent le contrôle de tout le parcours client, SDeal permet aux partenaires de grandir tout en gardant le contrôle. Nous offrons un soutien indépendant et une puissance marketing sans devenir votre concurrent.',
    
    // Footer
    privacyPolicy: 'Politique de confidentialité',
    termsConditions: 'Conditions générales',
    jobs: 'Emplois',
    
    // Language names
    english: 'Anglais',
    dutch: 'Néerlandais',
    german: 'Allemand',
    french: 'Français',
    
    // Products
    products: 'Nos Produits',
    productsIntro: 'Découvrez notre gamme complète de produits et services conçus pour aider votre entreprise à croître.',
    catalogSearchTitle: 'Catalogue produits',
    catalogSearchPlaceholder: 'Rechercher par nom ou SKU (min. 2 caractères)',
    catalogSearchButton: 'Rechercher',
    catalogEmpty: 'Aucun produit correspondant dans notre catalogue pour le moment.',
    catalogHint: 'Parcourir tous les produits actifs ou affiner avec la recherche.',
    catalogLoadError: 'Impossible de charger le catalogue. Réessayez plus tard.',
    catalogUnauthorized: 'Session expirée ou accès refusé. Connectez-vous à nouveau en tant qu’administrateur.',
    catalogViewOnShop: 'Voir',
    catalogLoading: 'Chargement…',
    catalogOf: 'sur',
    catalogPagination: 'Pagination',
    catalogPrevPage: 'Page précédente',
    catalogNextPage: 'Page suivante',
    catalogShow: 'Afficher',
    catalogSortBy: 'Trier par',
    catalogSortPosition: 'Nom A–Z',
    catalogSortNameDesc: 'Nom Z–A',
    catalogSortPriceAsc: 'Prix : croissant',
    catalogSortPriceDesc: 'Prix : décroissant',
    catalogViewMode: 'Mode d’affichage',
    catalogViewGrid: 'Grille',
    catalogViewList: 'Liste',
    catalogType: 'Type',
    marketplace: 'Plateforme de Marché',
    marketplaceDesc: 'Plateforme e-commerce avancée connectant les détaillants et grossistes avec les consommateurs à travers l\'Europe.',
    marketplaceDetailed: 'SDeal Marketplace\n\nSDeal est une place de marché internationale où les vendeurs peuvent proposer leurs produits aux consommateurs dans sept pays européens. La plateforme combine la portée d\'un grand canal de vente avec l\'automatisation marketing intelligente. Les vendeurs obtiennent un contrôle total sur leurs prix, commissions et offres de produits, tandis que SDeal gère le trafic, la publicité et l\'optimisation des conversions.\n\nLa force de SDeal réside dans le lien entre le marketing de performance et les ventes sur la place de marché. Pour chaque produit, la commission fixée est directement utilisée pour attirer un trafic ciblé, notamment via Google Shopping. Les prix compétitifs et les produits demandés sont donc automatiquement récompensés par une plus grande visibilité.\n\nSDeal offre également aux vendeurs un outil de repricing et un tableau de bord complet pour suivre les performances de vente et optimiser les prix. De cette façon, les vendeurs peuvent rivaliser sur le prix et la performance, tandis que la plateforme gère le marketing.\n\nNous offrons trois options:\n\n1. Place de marché avec commission fixe\nAvec une commission fixe, vous bénéficiez d\'un marketing automatique. SDeal gère le trafic, la publicité et l\'optimisation des conversions.\n\n2. Place de marché avec commission auto-définie\nAvec votre propre réglage de commission, vous bénéficiez également d\'un marketing automatique. SDeal gère le trafic, la publicité et l\'optimisation des conversions.\n\n3. CPC (CaaS)\nAvec Clicks as a Service, vous payez un montant mensuel fixe pour la visibilité et le trafic. Aucun marketing automatique n\'est effectué.\n\nEn bref: SDeal est une place de marché qui ne se contente pas de vendre, mais qui grandit activement avec les performances de ses vendeurs, transparente, évolutive et entièrement axée sur le rendement.',
    dealCSS: 'Productdeal.com CSS',
    dealCSSDesc: 'Jusqu\'à 20% de réduction sur les coûts de clic Google Shopping. Lorsque vous enchérissez 1 euro par clic, 100% va à la vente aux enchères au lieu de 80%, ce qui entraîne une augmentation d\'enchère de 25% sans effort supplémentaire.',
    dealCSSDetailed: 'Productdeal.com CSS\n\nAvec Productdeal.com CSS, SDeal offre aux vendeurs la possibilité de faire de la publicité via notre propre Comparison Shopping Service (CSS), un service de comparaison reconnu par Google.\n\nAu lieu de faire de la publicité directement via Google Shopping, l\'affichage des publicités passe par Productdeal.com CSS. Cela est non seulement entièrement compatible avec votre Merchant Center existant, mais offre également des avantages directs dans les enchères publicitaires de Google.\n\nQu\'est-ce qu\'un CSS?\n\nUn CSS (Comparison Shopping Service) est une partie indépendante qui affiche des publicités produits pour le compte de boutiques en ligne dans Google Shopping. Depuis que les règles européennes de concurrence exigent que Google partage son espace Shopping avec des fournisseurs externes, les vendeurs peuvent faire de la publicité moins cher via un CSS.\n\nPourquoi choisir Productdeal.com CSS\n\nJusqu\'à 20% de prix de clic plus bas (CPC)\nGoogle offre une réduction structurelle sur les clics achetés via un CSS externe. Les vendeurs qui font de la publicité via Productdeal.com CSS bénéficient donc directement de coûts par clic plus bas.\n\nPlus de visibilité avec le même budget\nGrâce à des prix de clic plus bas, vous pouvez générer plus de trafic avec le même budget publicitaire ou mieux performer dans la position d\'enchère de Google Shopping.\n\nFonctionne indépendamment de SDeal\nProductdeal.com CSS fonctionne avec votre Merchant Center existant. La configuration actuelle de votre Merchant Center reste exactement la même. Vous ne bénéficiez que de la réduction de Google sur les clics achetés via un CSS externe.\n\nTransparent et évolutif\nVous conservez un aperçu de vos performances et ne payez que les coûts réels de clic ou de plateforme, sans commissions cachées.\n\nEn résumé\n\nProductdeal.com CSS est le moyen intelligent de faire de la publicité pour vos produits via Google Shopping, avec des prix de clic plus bas, une visibilité accrue et sans complexité supplémentaire.\n\nVisitez productdeal.com pour en savoir plus sur Productdeal.com CSS.',
    productdealLinkSite: 'Productdeal.com',
    productdealLinkCss: 'Productdeal.com CSS',
    productdealLinkMore: 'En savoir plus sur Productdeal.com',
    cpc: 'CPC (Cost Per Click)',
    cpcDesc: 'CAAS (Clicks as a Service). Placez des produits qui mènent directement à votre propre boutique en ligne. Payez un montant mensuel fixe pour la visibilité et le trafic via SDeal au lieu d\'une commission par vente.',
    cpcDetailed: 'Clicks as a Service (CaaS)\n\nAvec Clicks as a Service (CaaS), SDeal offre aux vendeurs une nouvelle façon d\'être visible sur notre plateforme, sans que les ventes doivent passer par SDeal lui-même.\n\nAu lieu de facturer par vente, vous payez un montant mensuel fixe pour la visibilité et le trafic depuis la plateforme SDeal. Les visiteurs qui cliquent sur vos produits sont redirigés directement vers votre propre boutique en ligne.\n\nCaaS est idéal pour les marques et les détaillants qui veulent renforcer leur propre canal de vente, mais qui veulent également bénéficier de la portée, des comparaisons de produits et du trafic de SDeal.\n\nCe que cela implique\n\nMontant mensuel fixe, pas de commission\nVous payez un tarif clair par mois, indépendamment du chiffre d\'affaires ou du nombre de ventes.\n\nTrafic directement vers votre boutique en ligne\nLes clics sur les produits mènent directement à votre propre site, vous conservez donc le contact client et la gestion.\n\nVisibilité dans l\'écosystème SDeal\nVos produits apparaissent dans les catégories pertinentes et les résultats de recherche sur la plateforme.\n\nPas de campagnes, mais de la portée\nNous ne diffusons pas d\'annonces pour ces produits, mais assurons une visibilité organique via la plateforme et nos flux.\n\nEn résumé\n\nAvec CaaS, vous augmentez la visibilité de votre boutique en ligne via SDeal, sans commission par vente. Un moyen simple et transparent de générer du trafic supplémentaire et de renforcer votre marque, pour un montant mensuel fixe.',
    reviewFairifAI: 'Review (FairifAI)',
    reviewFairifAIDesc: 'Outil d\'évaluation avec l\'IA comme arbitre. Collectez des avis en invitant les clients à évaluer votre entreprise. L\'IA modère et évalue automatiquement tous les avis.',
    magentoDevelopment: 'Développement E-commerce',
    magentoDevelopmentDesc: 'Services de développement e-commerce professionnels. Modules personnalisés, intégrations, maintenance et optimisation pour votre plateforme e-commerce.',
    magentoDevelopmentDetailed: 'Service de Développement E-commerce\n\nAvec notre service de développement E-commerce, nous aidons les vendeurs et les marques à développer, optimiser et maintenir leur boutique en ligne. Basé sur notre propre expérience avec la plateforme SDeal, nous savons exactement ce qui est nécessaire pour construire des solutions e-commerce évolutives, rapides et axées sur la conversion.\n\nNous ne travaillons pas avec des freelancers indépendants ou des agences anonymes, mais avec une équipe dédiée de spécialistes e-commerce qui travaillent quotidiennement sur les performances, la stabilité et les intégrations avec les flux, les places de marché et les plateformes publicitaires.\n\nCe que vous obtenez\n\nExpertise E-commerce de la pratique\nNotre propre plateforme fonctionne sur une technologie e-commerce moderne, nous savons donc ce qu\'il faut pour construire des boutiques en ligne réussies.\n\nGuidance complète du projet\nChaque projet est géré par un product owner dédié, inclus dans le tarif.\n\nApproche transparente\nNous facturons un tarif horaire fixe de €75, y compris le product owner. Aucun coût caché, aucune surprise.\n\nDéploiement flexible\nDes optimisations ponctuelles au développement structurel ou aux contrats de maintenance.\n\nPlateformes Supportées\n\nNous fournissons des services de développement pour les plateformes e-commerce suivantes:\n\n• Magento & Magento2\n• ACC (Adobe Commerce Cloud)\n• Shopify\n• Big-commerce\n• Drupal\n• Prestashop\n• Laravel\n• Lightspeed\n• WordPress Development\n\nPour qui\n\nCe service est destiné aux boutiques en ligne qui:\n\nveulent améliorer ou accélérer leur environnement e-commerce existant;\n\nont besoin de nouveaux modules, intégrations ou mises à jour de design;\n\nveulent bénéficier d\'une équipe technique expérimentée sans les frais généraux d\'une grande agence.\n\nEn résumé\n\nAvec SDeal E-commerce Development, vous choisissez un partenaire expérimenté qui non seulement construit des solutions e-commerce, mais vit avec quotidiennement. Techniquement solide, commercialement intelligent et entièrement transparent en termes de coûts et d\'exécution. Pour €75 par heure, y compris le product owner.',
    ownMagentoStore: 'Boutique Magento Propre',
    ownMagentoStoreDesc: 'Solutions complètes de boutique Magento. De la configuration à la personnalisation, nous vous aidons à construire et maintenir votre propre boutique e-commerce puissante.',
    ownMagentoStoreDetailed: 'Boutique Magento Propre\n\nVoulez-vous une boutique en ligne professionnelle sans avoir à tout construire à partir de zéro? Avec SDeal Magento Store, nous offrons un environnement complètement configuré basé sur notre propre plateforme, développée et affinée sur plusieurs années.\n\nNotre infrastructure est optimisée pour la vitesse, la sécurité et l\'évolutivité. Vous profitez directement de la même base stable sur laquelle fonctionne la plateforme SDeal elle-même, y compris les intégrations avec les fournisseurs de paiement, les services d\'expédition et les flux de produits.\n\nCe que vous obtenez\n\nBoutique en ligne Magento 2 complète\nConstruite sur une base éprouvée avec des thèmes modernes et des performances optimales.\n\nHébergement, maintenance et mises à jour inclus\nNous nous occupons de la sécurité, de la stabilité et des optimisations régulières.\n\nIntégration avec SDeal et les places de marché externes\nPubliez facilement des produits sur plusieurs canaux de vente depuis un environnement central.\n\nSupport de notre équipe de développement\nNotre équipe Magento est prête pour la personnalisation et la croissance.\n\nCoûts\n\nCoûts d\'installation: €1 995 (une fois)\n\nCoûts mensuels: €299 par mois (y compris l\'hébergement, la maintenance et le support)\n\nEn résumé\n\nAvec SDeal Magento Store, vous disposez d\'une boutique en ligne Magento 2 puissante et sans maintenance, basée sur des années d\'expérience pratique et optimisée quotidiennement pour les performances et la conversion. Vous vous concentrez sur la vente, nous nous assurons que tout fonctionne.',
    analytics: 'Analytics & Insights',
    analyticsDesc: 'Outils d\'analyse de données et d\'intelligence d\'affaires complets pour optimiser vos performances de vente.',
    support: 'Support 24/7',
    supportDesc: 'Service client et assistance technique 24h/24 et 7j/7 pour tous nos partenaires.',
    
    // Pricing
    pricingTitle: 'Tarifs SDeal 2026',
    pricingDescription: 'Développez le chiffre d\'affaires de votre boutique en ligne avec un accès direct à plus de 200 millions de consommateurs en Europe. Les forfaits mensuels sont live en NL & BE ; un forfait annuel ouvre tous les pays.',
    pricingSubtitle: 'Développez le chiffre d\'affaires de votre boutique en ligne avec un accès direct à plus de 200 millions de consommateurs en Europe. Mensuel : NL & BE. Annuel : tous les pays.',
    billingPeriod: 'Période de facturation',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    yearlySave: 'Économisez 25%',
    perMonth: 'mois',
    perYear: 'an',
    noSetupCosts: 'Aucun frais d\'installation',
    startSellingToday: 'Commencez à vendre aujourd\'hui',
    scaleSalesToday: 'Développez vos ventes aujourd\'hui',
    maximizeRevenueToday: 'Maximisez vos revenus aujourd\'hui',
    packageCountriesFeatureMonthly: 'Accès complet à SDeal & Sportdeal aux Pays-Bas et en Belgique',
    packageCountriesFeatureYearly: 'Accès complet à SDeal & Sportdeal dans tous les pays',
    packageA: 'Starter',
    packageASubtitle: 'Parfait pour les nouvelles boutiques et celles en croissance',
    packageAFeature1: '€ 29,00 p.m. fixe',
    packageAFeature2: 'Accès complet à SDeal & Sportdeal aux Pays-Bas et en Belgique',
    packageAFeature3: 'Commission à partir de 15%, automatiquement réinvestie pour booster vos ventes',
    packageAFeature4: 'Démarrage rapide avec des intégrations puissantes',
    packageAFeature5: 'Tableau de bord avancé, rapports et analyses pour optimiser les performances',
    packageB: 'Growth',
    packageBSubtitle: 'Conçu pour la croissance, les volumes élevés et des marges renforcées',
    packageBMostPopular: 'Le plus populaire',
    packageBFeature1: '€ 49,00 p.m. fixe',
    packageBFeature2: 'Accès complet à SDeal & Sportdeal aux Pays-Bas et en Belgique',
    packageBFeature3: 'Commission à partir de 8%, entièrement investie dans le growth marketing',
    packageBFeature4: 'Contrôle total des prix, marges et stratégie',
    packageBFeature5: 'Scalez plus vite avec des intégrations avancées',
    packageBFeature6: 'Tableau de bord détaillé, rapports et analyses',
    packageBFeature7: 'Outil Repricer inclus',
    packageC: 'Pro',
    packageCSubtitle: 'Maximisez portée, contrôle et revenus en NL & BE',
    packageCSubtitleMonthly: 'Maximisez portée, contrôle et revenus en NL & BE',
    packageCSubtitleYearly: 'Maximisez portée, contrôle et revenus dans tous les pays',
    packageCFullPackage: 'Forfait complet',
    packageCFeature1: '€ 99,- p.m. fixe',
    packageCFeature2: 'Définissez votre commission (min. 8 %) – entièrement réinvestie dans le marketing',
    packageCFeature3: 'Outil Repricer, automatisez les ajustements de prix et restez compétitif',
    packageCFeature4: 'Tableau de bord avancé et accompagnement expert, suivi et optimisation des performances',
    packageCFeature5: 'Accès aux Pays-Bas et en Belgique ; tous les pays avec un forfait annuel',
    packageCFeature6: 'FairifAI (outil d\'avis Pro), modération des avis par IA',
    packageCFeature7: 'Productdeal.com CSS, économisez jusqu\'à 20 % sur vos coûts Google Shopping',
    packageCFeature8: 'Productdeal.com CSS (via SDeal) – Jusqu\'à 20 % de réduction sur les coûts de clic Google Shopping',
    addonsTitle: 'ADD ONS',
    moreInfo: 'Plus d\'infos',
    addonFairifAI: 'FairifAI',
    addonFairifAIPrice: 'Voir les tarifs',
    addonDEALCSS: 'Productdeal.com CSS',
    addonDEALCSSPrice: '€24,95 et €14,95 p.m. pour les clients de la plateforme SDeal',
    addonDEALCSSDescription: 'Lorsqu\'un annonceur enchérit 1 euro par clic via Google Shopping CSS, seulement 80 centimes de cette enchère sont alloués à la vente aux enchères. Cependant, avec Productdeal.com CSS, 100% de votre enchère va à la vente aux enchères. Cela se traduit par une augmentation d\'enchère de 25% sans effort d\'enchère supplémentaire.',
    addonCPC: 'CPC (Cost per click)',
    addonCPCPrice: '€39,95 p.m.',
    addonCPCDescription: 'CAAS (Clicks as a Service). Avec CAAS, les vendeurs peuvent placer des produits qui ne sont pas facturés via SDeal, mais qui mènent directement à leur propre boutique en ligne. Au lieu d\'une commission par vente, ils paient un montant mensuel fixe pour la visibilité et le trafic via SDeal.',
    addonMagentoDevelopment: 'Développement E-commerce',
    addonMagentoDevelopmentPrice: 'Contacter pour prix',
    addonMagentoDevelopmentDescription: 'Services de développement e-commerce professionnels. Modules personnalisés, intégrations, maintenance et optimisation pour votre plateforme e-commerce.',
    addonOwnMagentoStore: 'Boutique Magento Propre',
    addonOwnMagentoStorePrice: '€1 995 installation + €199 p.m.',
    addonOwnMagentoStoreDescription: 'Solutions complètes de boutique Magento. De la configuration à la personnalisation, nous vous aidons à construire et maintenir votre propre boutique e-commerce puissante.',
    
    // Package Selection Page
    packageHeroTitle: 'Choisissez votre forfait SDeal',
    packageHeroSubtitle: 'Choisissez votre forfait ci-dessous – cela prend moins de 30 secondes et vous pourrez ensuite vendre directement sur SDeal.',
    packageWhyTitle: 'Pourquoi cette mise à jour?',
    packageWhyText: 'SDeal a commencé comme un marketplace tiers pur. Nous avons remarqué que le modèle de commission traditionnel crée involontairement des désavantages pour les vendeurs. Lorsqu\'une commission plus élevée est demandée, une pression sur les marges se crée pour le vendeur. Il devient ainsi plus difficile d\'offrir des prix consommateurs compétitifs, ce qui a un effet direct sur la conversion, le volume et la compétitivité.\n\nEn passant à un modèle hybride marketplace + SaaS où la commission est entièrement utilisée comme budget marketing et notre modèle de revenus se trouve dans le prix du forfait fixe, nous évitons cette pression sur les marges. Les vendeurs conservent ainsi plus d\'espace pour offrir des prix compétitifs, ce qui conduit finalement à plus de ventes et à un écosystème plus sain pour tous.',
    packageChooseTitle: 'Choisissez votre forfait',
    choosePackage: 'Choisir',
    packageSelectA: 'Starter',
    packageAPrice: '€29 par mois',
    packageADesc1: 'Commission standard (minimum 15%)',
    packageADesc2: 'Accès complet à la plateforme SDeal',
    packageADesc3: 'Gestion automatique des campagnes en NL & BE (tous les pays avec un forfait annuel)',
    packageADesc4: 'Adapté aux assortiments petits à moyens',
    packageSelectB: 'Growth',
    packageBPrice: '€49 par mois',
    packageBDesc1: 'Vous déterminez votre propre commission (minimum 8%)',
    packageBDesc2: '100% de la commission est utilisée comme budget marketing',
    packageBDesc3: 'Accès complet à la plateforme SDeal',
    packageBDesc4: 'Idéal si vous pilotez activement avec le prix et la marge',
    packageSelectC: 'Pro',
    packageCPrice: '€99 par mois',
    packageCDesc1: 'Déterminez votre propre commission (minimum 8%)',
    packageCDesc2: 'Incluant l\'accès à Productdeal.com CSS',
    packageCDesc3: 'Pour une visibilité et une croissance maximales',
    packageCDesc4: 'Peut être complété par CAAS (Clicks as a Service) vers votre propre boutique en ligne',
    packageChangeNote: 'Vous pouvez toujours ajuster votre forfait plus tard en consultation si votre situation change.',
    packageSummaryTitle: 'Résumé du Forfait Sélectionné',
    packageSummaryPackage: 'Forfait',
    packageSummarySellerId: 'ID Vendeur',
    packageSummaryStartDate: 'Date de début',
    packageSummaryCommission: 'Commission',
    packageSummaryBilling: 'Période de facturation',
    packageSummaryTotal: 'Prix total',
    packageSummaryTotalPerMonth: 'par mois',
    packageSummaryTotalPerYear: 'par an',
    packageAddonsTitle: 'Add-ons optionnels',
    paymentTitle: 'Paiement',
    paymentTitlePlatformFee: 'Frais de plateforme (abonnement)',
    proceedToPayment: 'Procéder au paiement',
    proceedToMandatePayment: 'Confirmer avec 0,01 € (mandat SEPA)',
    paymentPlatformFeeNote: 'Ce paiement correspond aux frais de plateforme (votre abonnement au forfait). Les paiements des commandes passées via notre plateforme sont distincts et suivent la fréquence hebdomadaire ou mensuelle que vous avez choisie.',
    paymentMandatePromoNote: 'Avec votre code promo, vous ne payez que 0,01 € pour mettre en place un mandat SEPA — pas le montant complet du forfait. La facturation normale du forfait commence après la période gratuite (à partir du 1er janvier selon l’offre).',
    packageSummaryPromoCode: 'Code promo',
    packageSummaryFirstPayment: 'Premier paiement maintenant',
    packageSummaryMandateOnly: 'vérification du mandat uniquement',
    packageSummaryRegularWouldBe: 'Prix normal du forfait',
    paymentSuccessTitle: 'Paiement réussi!',
    paymentSuccessMessage: 'Votre paiement a été traité avec succès. Votre abonnement est maintenant actif.',
    paymentSuccessDetails: 'Vous recevrez un e-mail de confirmation avec tous les détails. Merci d\'avoir choisi SDeal!',
    yearlyDiscount: '30% de réduction',
    sellerIdLabel: 'ID Vendeur',
    sellerIdPlaceholder: 'Entrez votre ID vendeur',
    sellerEmailLabel: 'Adresse e-mail',
    sellerEmailPlaceholder: 'Entrez votre adresse e-mail',
    generalEmailLabel: 'Adresse e-mail générale',
    generalEmailPlaceholder: 'E-mail de contact principal de votre boutique',
    financeEmailLabel: 'E-mail finance',
    financeEmailPlaceholder: 'Factures et finance (optionnel)',
    orderEmailLabel: 'E-mail commandes',
    orderEmailPlaceholder: 'Notifications de commandes (optionnel)',
    sellerInfoTitle: 'Vos informations',
    sellerInfoDescription: 'Veuillez entrer votre adresse e-mail et votre ID vendeur pour continuer',
    customerTypeTitle: 'Êtes-vous un nouveau client ou un client existant?',
    customerTypeNew: 'Nouveau Client',
    customerTypeNewDescription: 'Je ne suis pas encore client chez SDeal',
    customerTypeExisting: 'Client Existant',
    customerTypeExistingDescription: 'J\'ai déjà un ID vendeur',
    newCustomerTitle: 'Détails d\'inscription',
    newCustomerDescription: 'Remplissez vos coordonnées pour vous inscrire',
    companyNameLabel: 'Nom de l\'entreprise',
    companyNamePlaceholder: 'Entrez le nom de votre entreprise',
    displayNameLabel: 'Nom affiché',
    displayNamePlaceholder: 'Nom de votre boutique sur SDeal',
    displayNameHelp: 'C’est le nom vu par les clients sur SDeal (nom de boutique Magento). Le nom d’entreprise peut être votre raison sociale.',
    displayNameRequired: 'Le nom affiché est obligatoire',
    firstNameLabel: 'Prénom',
    firstNamePlaceholder: 'Entrez votre prénom',
    lastNameLabel: 'Nom de famille',
    lastNamePlaceholder: 'Entrez votre nom de famille',
    streetLabel: 'Rue et numéro',
    streetPlaceholder: 'ex. Rue Principale 123',
    cityLabel: 'Ville',
    cityPlaceholder: 'Entrez votre ville',
    postalCodeLabel: 'Code postal',
    postalCodePlaceholder: 'ex. 75001',
    countryLabel: 'Pays',
    countryPlaceholder: 'Sélectionnez votre pays',
    phoneLabel: 'Numéro de téléphone',
    phonePlaceholder: 'ex. +33 1 23 45 67 89',
    kvkNumberLabel: 'Numéro SIRET',
    kvkNumberPlaceholder: 'ex. 12345678901234',
    vatNumberLabel: 'Numéro TVA',
    vatNumberPlaceholder: 'ex. FR12345678901',
    ibanLabel: 'IBAN',
    ibanPlaceholder: 'ex. FR76 1234 5678 9012 3456 7890 123',
    bicLabel: 'BIC',
    bicPlaceholder: 'ex. BNPAFRPPXXX',
    countryNL: 'Pays-Bas',
    countryBE: 'Belgique',
    countryDE: 'Allemagne',
    countryFR: 'France',
    countryGB: 'Royaume-Uni',
    countryAT: 'Autriche',
    countryIT: 'Italie',
    countryDK: 'Danemark',
    countrySE: 'Suède',
    countryPL: 'Pologne',
    countryES: 'Espagne',
    countryCZ: 'Tchéquie',
    sellCountriesTitle: 'Pays dans lesquels vous souhaitez vendre',
    sellCountriesHint: 'Les Pays-Bas et la Belgique sont toujours disponibles. Les pays supplémentaires nécessitent un forfait annuel, car nous fournissons les traductions pour ces marchés.',
    sellCountriesBaseGroup: 'Toujours disponible',
    sellCountriesExtraGroup: 'Pays supplémentaires (forfait annuel obligatoire)',
    sellCountriesYearlyRequiredHint: 'Pour ces pays, nous fournissons les traductions. Un forfait annuel est alors le minimum.',
    sellCountriesYearlyRequiredNotice: 'Vous avez sélectionné un ou plusieurs pays supplémentaires. Un forfait annuel est obligatoire pour les traductions sur ces marchés. Le paiement mensuel est désactivé.',
    sellCountriesYearlyRequiredError: 'Un forfait annuel est obligatoire pour vendre dans des pays autres que les Pays-Bas et la Belgique.',
    sellCountriesMonthlyDisabledNote: 'Indisponible avec des pays supplémentaires',
    payoutFrequencyTitle: 'Fréquence de paiement pour les commandes via notre système',
    payoutFrequencyWeekly: 'Hebdomadaire',
    payoutFrequencyMonthly: 'Mensuel',
    startDateTitle: 'Date de début',
    startDateImmediate: 'Immédiat',
    startDate2026: '1er janvier 2026',
    commissionPercentageLabel: 'Pourcentage de commission',
    commissionPercentagePlaceholder: 'Entrez le pourcentage',
    commissionPercentageMinA: 'Minimum 15%',
    commissionPercentageMinBC: 'Minimum 8%',
    packageAddonDEALCSS: 'Productdeal.com CSS – Comparison Shopping Service – €24,95 p.m.',
    packageAddonCAAS: 'CAAS – Clicks as a Service (CPC vers votre propre boutique en ligne) – €39,95 p.m.',
    packageAddonFairifAI: 'Gestion de la réputation des avis (Fairifai) – voir fairifai.com pour les prix',
    packageConfirmTitle: 'Confirmez votre accord',
    packageConfirmText: 'Le SDeal Seller Agreement 8.0 et les SDeal Seller Terms & Conditions 8.0 s\'appliquent à votre compte. Vous pouvez consulter ces documents ici:',
    packageAgreementLink: 'Télécharger le SDeal Seller Agreement 8.0',
    packageTermsLink: 'Télécharger les SDeal Seller Terms & Conditions 8.0',
    packageRegistrationLink: 'Télécharger le SDeal Seller Registration Form 8.0',
    packageAgreementCheckbox: 'J\'accepte le SDeal Seller Agreement 8.0 et les SDeal Seller Terms & Conditions 8.0, et je confirme qu\'ils s\'appliquent à ma coopération avec SDeal.',
    packageLegalNote1: 'En choisissant votre forfait et en acceptant, vous continuez sous le SDeal Seller Agreement et les Seller Terms & Conditions en vigueur.',
    packageLegalNote2: 'Si vous vendez via SDeal sans remplir ce formulaire, le SDeal Seller Agreement 8.0 et les SDeal Seller Terms & Conditions 8.0 s\'appliquent néanmoins.',
    packageCTAButton: 'Confirmer & continuer',
    packageCTANote: 'Après confirmation, vous recevrez un e-mail avec un aperçu de votre forfait choisi et une copie de la documentation pour votre propre administration.',
    packageFAQTitle: 'FAQ – questions fréquemment posées',
    packageFAQ1Question: 'Que se passe-t-il si je ne fais pas de choix?',
    packageFAQ1Answer: 'Votre accord actuel se termine le 31 décembre 2025. Nous vous contacterons pour convenir d\'un forfait approprié. Tant que vous n\'avez pas choisi de forfait, nous pouvons limiter votre support marketing et plateforme.',
    packageFAQ2Question: 'Mes prix ou produits existants changent-ils?',
    packageFAQ2Answer: 'Non. Vous gardez vos produits, prix et contenu. Ce qui change, c\'est la façon dont nous structurons ensemble le budget marketing et notre rémunération.',
    packageFAQ3Question: 'Puis-je changer de forfait plus tard?',
    packageFAQ3Answer: 'Oui, en consultation, vous pouvez changer de forfait entre-temps si cela correspond mieux à votre volume ou à votre stratégie.',
    
    // About
    ourMission: 'Notre Mission',
    ourApproach: 'Notre Approche',
    
    // Contact
    sales: 'Équipe Commerciale',
    contactIntro: 'Contactez notre équipe. Nous sommes là pour vous aider avec toutes vos questions sur SDeal ou Fairifai.',
    scheduleCall: 'Planifier un Appel',
    otherWays: 'Autres Moyens de Nous Contacter',
    email: 'E-mail',
    phone: 'Téléphone',
    address: 'Adresse',
    
    // Connections
    connectionsIntro: 'SDeal propose des intégrations fluides avec les systèmes e-commerce les plus couramment utilisés. Cela permet aux vendeurs de connecter rapidement et facilement leur boutique en ligne, la gestion des commandes et les flux de produits vers notre plateforme.',
    
    // Partners
    partners: 'Nos Partenaires',
    partnersIntro: 'SDeal collabore avec des partenaires industriels de premier plan pour offrir la meilleure expérience possible à nos clients. Ces partenariats nous permettent d\'offrir des solutions innovantes, une sécurité renforcée et des services fiables.',
         visitPartner: 'Visiter le Partenaire',
     interestedPartnership: 'Intéressé par un partenariat?',
     partnershipDescription: 'Êtes-vous intéressé par un partenariat avec SDeal? Nous recherchons toujours des entreprises innovantes qui partagent notre vision d\'un achat en ligne fiable et sécurisé. Contactez-nous pour discuter des opportunités de partenariat.',
     contactUs: 'Contactez-nous',
     contactForPartnership: 'Contactez-nous pour les Opportunités de Partenariat',
     
     // Jobs
     joinOurTeam: 'Rejoignez Notre Équipe',
     jobsIntro: 'Nous recherchons actuellement des talents de premier plan pour rejoindre notre équipe en pleine croissance. Découvrez des opportunités qui correspondent à vos compétences et ambitions.',
     fullTimePositions: 'Postes à Temps Plein',
     traineeships: 'Stages',
     traineeshipIntro: 'Nous recherchons régulièrement de jeunes talents motivés qui souhaitent développer leurs compétences dans leur domaine.',
     interestedInJoining: 'Intéressé à Rejoindre Notre Équipe?',
     contactUsJobs: 'L\'un des postes ci-dessus vous convient-il parfaitement? N\'hésitez pas et contactez-nous à',
     viewDetails: 'Voir les Détails',
     applyNow: 'Postuler Maintenant',
     keyResponsibilities: 'Responsabilités Clés',
     requirements: 'Exigences',
     whatWeOffer: 'Ce Que Nous Offrons',

    // Dashboard menu
    menuLabel: 'MENU',
    dashboard: 'Tableau de bord',
    dashboardProducts: 'Produits',
    dashboardOrders: 'Commandes',
    dashboardDisputes: 'Litiges',
    dashboardReturns: 'Retours',
    dashboardPerformance: 'Performance',
    dashboardFinance: 'Finance',
    dashboardPayout: 'Paiement',
    dashboardInvoice: 'Facture',
    dashboardSettings: 'Paramètres',
    dashboardFeed: 'Fil',
    dashboardFaq: 'FAQ',
    dashboardNews: 'Actualités',

    dashboardTotalProductsLive: 'Total produits en ligne',
    dashboardToProducts: 'Vers les produits',
    dashboardTotalProductsAdvertised: 'Total produits annoncés',
    dashboardGood: 'Bien',
    dashboardPreferredSeller: 'Vendeur préféré (SportDeal NL)',
    dashboardToPreferredSeller: 'Vers vendeur préféré >>',
    dashboardTotalRevenue: 'Chiffre d\'affaires total',
    dashboardMonthlyRevenue: 'Chiffre d\'affaires mensuel',
    dashboardOrdersLabel: 'Commandes',
    dashboardRevenue: 'Chiffre d\'affaires',
    dashboardRevenuePerCountry: 'Chiffre d\'affaires par pays',
    dashboardLast12Months: '12 derniers mois',
    dashboardNotPreferred: 'Non préféré',

    // Finance (Balance Management)
    financeTitle: 'Finance - Gestion des soldes',
    balancePendingLabel: 'Solde en attente (en attente de confirmation)',
    balanceConfirmedLabel: 'Solde vendeur (confirmé)',
    balanceAvailableLabel: 'Solde disponible (prêt pour paiement)',
    balanceRefundLabel: 'Solde remboursement (pour remboursements)',
    sellerReserveLabel: 'Réserve vendeur (pour paiements négatifs)',
    addFundsButton: 'Ajouter des fonds',
    automaticPaymentsButton: 'Paiements automatiques acceptés',
    balanceNoteTitle: 'Note de solde',
    balanceNotePending: 'Le solde (en attente de confirmation) n\'est pas encore confirmé.',
    balanceNoteConfirmed: 'Le solde (confirmé) est en attente de disponibilité.',
    balanceNoteAvailable: 'Le solde disponible est utilisé pour le prochain paiement. Il est rechargé chaque jeudi.',
    balanceNoteRefund: 'Le solde remboursement sert aux remboursements. En cas d\'insuffisance, rechargez votre solde.',
    balanceNoteReserve: 'Réserve vendeur : tampon pour les rétrofacturations ou annulations. En dessous de 0 €, rechargez pour restaurer.',
    financeLoading: 'Chargement…',

    // Orders list
    ordersTitle: 'Commandes',
    ordersStatus: 'Statut des commandes',
    ordersCompleted: 'Terminé',
    ordersWaiting: 'En attente',
    ordersCanceled: 'Annulé',
    downloadPdf: 'Télécharger PDF',
    downloadCsv: 'CSV',
    orderDownloadList: 'Liste des commandes',
    recordsFound: 'résultats',
    perPage: 'par page',
    ordersFilters: 'Filtres',
    ordersColumns: 'Colonnes',
    ordersColProduct: 'Nom du produit',
    ordersColOrderId: 'ID commande',
    ordersColTotalCustomer: 'Montant total client',
    ordersColOrderAmount: 'Montant commande',
    ordersColCustomer: 'Client',
    ordersColCustomerOrderId: 'ID commande client',
    ordersColOrderStatus: 'Statut commande',
    ordersColCommission: 'Commission',
    ordersColCreatedDate: 'Date de création',
    ordersColInternalStatus: 'Statut interne',
    ordersColFinanceStatus: 'Statut finance',
    ordersColPaypalDisputes: 'Litiges Paypal',
    ordersColView: 'Voir',
    orderStatusWaiting: 'En attente de confirmation',
    orderStatusConfirmed: 'Confirmé',
    orderStatusCanceled: 'Annulé',
    orderStatusCompleted: 'Terminé',
    financeStatusSettled: 'Réglé',
    financeStatusPaid: 'Payé',
    financeStatusInvoiceAccepted: 'Facture acceptée',
    noDispute: 'Aucun litige',
    ofPages: 'sur',
    ordersEmpty: 'Aucune commande',
    orderDetailTitle: 'Commande',
    orderStatusLabel: 'Statut commande',
    financeStatusLabel: 'Statut finance',
    orderDetailDownload: 'Télécharger',
    orderDetailCsv: 'CSV',
    orderDetailPrintPacking: 'Imprimer bons de livraison',
    orderCanceledBtn: 'Commande annulée',
    orderDate: 'Date commande',
    expectedArrivalDate: 'Date d\'arrivée prévue',
    orderIdCustomer: 'ID commande client',
    totalAmountCustomer: 'Montant total client',
    shippingName: 'Nom livraison',
    shippingAddress: 'Adresse livraison',
    billingName: 'Nom facturation',
    billingAddress: 'Adresse facturation',
    costPrice: 'Coût',
    deliveryCost: 'Frais de livraison',
    payout: 'Paiement',
    paymentScheduledOn: 'Paiement prévu le',
    commission: 'Commission',
    contactCustomer: 'Contact client',
    orderStore: 'Boutique',
    backToOrders: 'Retour aux commandes',
    'orderDetailN/A': 'N/D',
  }
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations.en[key] || key;
}; 